import Vue from 'vue';
import Router from 'vue-router';
import { PAGE_CODE, PERMISSION_TYPE } from './core/plugins/constants';
import { RESET_LAYOUT_CONFIG } from '@/core/services/store/config.module';
import { SET_PERMISSIONS } from '@/core/services/store/auth.module';
import intersection from 'lodash/intersection';
import MgrService from '@/core/services/security.service';
import store from '@/core/services/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  duplicateNavigationPolicy: 'reload',
  routes: [
    {
      path: '/',
      component: () => import('@/view/layout/Layout'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () => import('@/view/pages/Dashboard.vue'),
        },
        // ZOOM LINK CONVERTER
        {
          path: 'zoom-converter',
          name: 'zoom_converter',
          component: () =>
            import('@/view/pages/zoom_converter/ZoomLinkConverter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ZOOM_CONVERTER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [

              {
                name: 'Tổng quan tình trạng sức khỏe và các chỉ số bệnh lý',
                link: 'zoom-converter',
              },

              {
                name: 'Zoom Link Converter',
                active: true,
              },
            ],
          },
        },
        // USER DASHBOARD: BEGIN
        {
          path: 'user_dashboard',
          name: 'user_dashboard_find',
          component: () =>
            import('@/view/pages/user_dashboard/UserDashboard.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.USER_DASHBOARD,
            breadcrumb: [
              {
                name: 'Quản lý khách hàng',
              },
              {
                name: 'User dashboard',
              },
              {
                name: 'User dashboard',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_dashboard/:id',
          name: 'user_dashboard',
          component: () => import('@/view/pages/user_dashboard/index.vue'),
          redirect: '/user_dashboard/:id/over_view',
          meta: {
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.USER_DASHBOARD,
          },
          children: [
            {
              path: 'over_view',
              name: 'over_view',
              component: () =>
                import('@/view/pages/user_dashboard/pages/OverView.vue'),
              meta: {
                requiresAuth: true,
                permissions: [PERMISSION_TYPE.VIEW],
                pageCode: PAGE_CODE.USER_DASHBOARD,
                breadcrumb: [
                  {
                    name: 'User dashboard',
                  },
                  {
                    name: 'Tổng hợp',
                  },
                  {
                    name: 'Chỉ số tổng hợp',
                    active: true,
                  },
                ],
              },
            },
            {
              path: 'biological',
              name: 'biological',
              component: () =>
                import('@/view/pages/user_dashboard/pages/Biological.vue'),
              meta: {
                requiresAuth: true,
                permissions: [PERMISSION_TYPE.VIEW],
                pageCode: PAGE_CODE.USER_DASHBOARD,
                breadcrumb: [
                  {
                    name: 'User dashboard',
                  },
                  {
                    name: 'Chỉ số sinh học',
                  },
                  {
                    name: 'Chỉ số sinh học',
                    active: true,
                  },
                ],
              },
            },
            {
              path: 'schedule',
              name: 'schedule',
              component: () =>
                import('@/view/pages/user_dashboard/pages/Schedule.vue'),
              meta: {
                requiresAuth: true,
                permissions: [PERMISSION_TYPE.VIEW],
                pageCode: PAGE_CODE.USER_DASHBOARD,
                breadcrumb: [
                  {
                    name: 'User dashboard',
                  },
                  {
                    name: 'Lịch trình',
                  },
                  {
                    name: 'Lịch trình',
                    active: true,
                  },
                ],
              },
            },
            {
              path: 'lessons',
              name: 'lessons',
              component: () =>
                import('@/view/pages/user_dashboard/pages/Lesson.vue'),
              meta: {
                requiresAuth: true,
                permissions: [PERMISSION_TYPE.VIEW],
                pageCode: PAGE_CODE.USER_DASHBOARD,
                breadcrumb: [
                  {
                    name: 'User dashboard',
                  },
                  {
                    name: 'Bài học',
                  },
                  {
                    name: 'Danh sách bài học',
                    active: true,
                  },
                ],
              },
            },
            {
              path: 'survey_result',
              name: 'survey_result',
              component: () =>
                import('@/view/pages/user_dashboard/pages/SurveyResult.vue'),
              meta: {
                requiresAuth: true,
                permissions: [PERMISSION_TYPE.VIEW],
                pageCode: PAGE_CODE.USER_DASHBOARD,
                breadcrumb: [
                  {
                    name: 'User dashboard',
                  },
                  {
                    name: 'Kết quả khảo sát',
                  },
                  {
                    name: 'Danh sách kết quả khảo sát',
                    active: true,
                  },
                ],
              },
            },
            {
              path: 'student_report',
              name: 'student_report',
              component: () =>
                import('@/view/pages/user_dashboard/pages/StudentReport.vue'),
              meta: {
                requiresAuth: true,
                permissions: [PERMISSION_TYPE.VIEW],
                pageCode: PAGE_CODE.USER_DASHBOARD,
                breadcrumb: [
                  {
                    name: 'User dashboard',
                  },
                  {
                    name: 'Báo cáo học viên',
                  },
                  {
                    name: 'Danh sách báo cáo học viên',
                    active: true,
                  },
                ],
              },
            },
          ],
        },
        // USER DASHBOARD: END

        // PATIENT: BEGIN
        {
          path: 'patient',
          name: 'patient_list',
          component: () => import('@/view/pages/patient/patientList.vue'),
        },
        {
          path: 'patient/:form_type/:id?',
          name: 'patient_detail',
          props: true,
          component: () => import('@/view/pages/Dashboard.vue'),
          meta: {},
        },
        {
          path: 'history_kpis',
          name: 'history_kpis',
          component: () =>
            import('@/view/pages/history_input_kpis/historyKPIsList.vue'),
        },
        // PATIENT: END
        // MANAGE USER GROUPS: BEGIN
        {
          path: 'user_group',
          name: 'user_group_list',
          component: () => import('@/view/pages/user_group/userGroupsList.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh sách nhóm người dùng',
                link: 'user_group_list',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_group/:form_type/:id?',
          name: 'user_group_detail',
          props: true,
          component: () =>
            import('@/view/pages/user_group/userGroupDetail.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh sách nhóm người dùng',
                link: 'user_group_list',
              },
              {
                createName: 'Thêm nhóm người dùng',
                editName: 'Chỉnh sửa nhóm người dùng',
                link: 'user_group_detail',
                active: true,
              },
            ],
          },
        },
        // MANAGE USER GROUPS: END
        // MANAGE ACCOUNT APP: BEGIN
        {
          path: 'user_app',
          name: 'user_app_list',
          component: () => import('@/view/pages/user_app/userAppList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_APP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản App',
              },
              {
                name: 'Danh sách tài khoản App',
              },
              {
                name: 'Danh sách tài khoản App',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_app/:id?',
          name: 'user_app_view',
          props: true,
          component: () => import('@/view/pages/user_app/userAppView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_APP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản App',
                link: 'user_app_list',
              },
              {
                name: 'Chi tiết tài khoản App',
              },
              {
                name: 'Chi tiết tài khoản App',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_app/:form_type/:id?',
          name: 'user_app_update',
          props: true,
          component: () => import('@/view/pages/user_app/userAppUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_APP,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản App',
                link: 'user_app_list',
              },
              {
                name: 'Chỉnh sửa tài khoản App',
              },
              {
                editName: 'Chỉnh sửa tài khoản App',
                active: true,
              },
            ],
          },
        },
        // MANAGE TRACKING SHARE APP
        {
          path: 'tracking_share_app',
          name: 'tracking_share_app',
          component: () => import('@/view/pages/tracking_share_app/List.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRACKING_SHARE_APP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Trang chủ',
              },
              {
                name: 'Tracking share app',
              },
              {
                name: 'Quản lý giới thiệu',
                active: true,
              },
            ],
          },
        },
        // MANAGE ACCOUNT APP: END
        // MANAGE ACCOUNT PORTAL: BEGIN
        {
          path: 'user_portal',
          name: 'user_portal_list',
          component: () =>
            import('@/view/pages/user_portal/userPortalList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_PORTAL,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản Portal',
              },
              {
                name: 'Danh sách tài khoản Portal',
              },
              {
                name: 'Danh sách tài khoản Portal',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_portal/view/:id',
          name: 'user_portal_view',
          props: true,
          component: () =>
            import('@/view/pages/user_portal/userPortalView.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh mục tài khoản Portal',
                link: 'user_portal_list',
              },
              {
                name: 'Chi tiết tài khoản Portal',
                link: 'user_portal_view',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_portal/:form_type/:id?',
          name: 'user_portal_detail',
          props: true,
          component: () =>
            import('@/view/pages/user_portal/userPortalDetail.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh mục tài khoản Portal',
                link: 'user_portal_list',
              },
              {
                createName: 'Thêm mới tài khoản Portal',
                editName: 'Chỉnh sửa tài khoản Portal',
                link: 'user_portal_detail',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach_profile/create',
          name: 'coach_profile_create',
          props: true,
          component: () =>
            import('@/view/pages/coach_profile/CoachProfileCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_PORTAL,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản Portal',
                link: 'user_portal_list',
              },
              {
                name: 'Thêm mới tài khoản Portal',
              },
              {
                name: 'Tạo mới tài khoản',
                link: 'coach_profile_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach_profile/:id',
          name: 'coach_profile_detail',
          props: (route) => ({
            id: route.params.id,
          }),
          component: () =>
            import('@/view/pages/coach_profile/CoachProfileDetail.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_PORTAL,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản Portal',
                link: 'user_portal_list',
              },
              {
                name: 'Chi tiết tài khoản Portal',
              },
              {
                name: 'Chi tiết tài khoản',
                link: 'coach_profile_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach_profile/edit/:id',
          name: 'coach_profile_edit',
          component: () =>
            import('@/view/pages/coach_profile/CoachProfileUpdate.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ACCOUNT_PORTAL,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý tài khoản Portal',
                link: 'user_portal_list',
              },
              {
                name: 'Chỉnh sửa tài khoản Portal',
              },
              {
                name: 'Chỉnh sửa tài khoản',
                link: 'coach_profile_create',
                active: true,
              },
            ],
          },
        },
        // MANAGE ACCOUNT PORTAL: END
        // PERMISSION_ROLE: BIGIN
        {
          path: 'permission_role',
          name: 'permission_role',
          component: () =>
            import('@/view/pages/permission_role/permission_role.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_ROLE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý vai trò',
              },
              {
                name: 'Danh sách vai trò',
              },
              {
                name: 'Danh sách vai trò',
                active: true,
              },
            ],
          },
        },
        // PERMISSION_ROLE: END
        // DEPARTMENT: BEGIN
        {
          path: 'department',
          name: 'department',
          component: () =>
            import('@/view/pages/permission_role/department.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACCOUNT_DEPARTMENT,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý vai trò',
              },
              {
                name: 'Quản lý phòng ban',
              },
              {
                name: 'Quản lý phòng ban',
                active: true,
              },
            ],
          },
        },
        // DEPARTMENT: END
        // SDK PARTNER: BEGIN
        {
          path: 'sdk-partner',
          name: 'sdk_partner',
          component: () => import('@/view/pages/sdk_partner/sdk_partner.vue'),
          meta: {
            requiresAuth: true,
            // TODO: bật lại gating khi backend đã seed permission SdkPartner
            // pageCode: PAGE_CODE.SDK_PARTNER,
            // permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý SDK Partner',
              },
              {
                name: 'Danh sách Partner',
              },
              {
                name: 'Danh sách Partner',
                active: true,
              },
            ],
          },
        },
        {
          path: 'sdk-partner/:id/logs',
          name: 'sdk_partner_logs',
          props: true,
          component: () => import('@/view/pages/sdk_partner/logs.vue'),
          meta: {
            requiresAuth: true,
            // TODO: bật lại gating khi backend đã seed permission SdkPartner
            // pageCode: PAGE_CODE.SDK_PARTNER,
            // permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý SDK Partner',
                link: 'sdk_partner',
              },
              {
                name: 'Audit Logs & Usage',
              },
              {
                name: 'Audit Logs & Usage',
                active: true,
              },
            ],
          },
        },
        {
          path: 'sdk-partner/stats',
          name: 'sdk_partner_stats',
          component: () => import('@/view/pages/sdk_partner/stats.vue'),
          meta: {
            requiresAuth: true,
            // TODO: bật lại gating khi backend đã seed permission SdkPartner
            // pageCode: PAGE_CODE.SDK_PARTNER,
            // permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý SDK Partner',
                link: 'sdk_partner',
              },
              {
                name: 'Thống kê sử dụng dịch vụ',
              },
              {
                name: 'Thống kê sử dụng dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'sdk-partner/request-logs',
          name: 'sdk_partner_request_logs',
          component: () => import('@/view/pages/sdk_partner/request-logs.vue'),
          meta: {
            requiresAuth: true,
            // TODO: bật lại gating khi backend đã seed permission SdkPartner
            // pageCode: PAGE_CODE.SDK_PARTNER,
            // permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý SDK Partner',
                link: 'sdk_partner',
              },
              {
                name: 'Tra cứu Request',
              },
              {
                name: 'Tra cứu Request',
                active: true,
              },
            ],
          },
        },
        // SDK PARTNER: END
        // HEALTH REPORT (GĐ3 Portal Review): BEGIN
        {
          path: 'health-report',
          name: 'health_report',
          component: () =>
            import('@/view/pages/health_report/HealthReportReview.vue'),
          meta: {
            requiresAuth: true,
            // TODO: bật lại gating khi backend đã seed permission HealthReport
            // pageCode: PAGE_CODE.HEALTH_REPORT,
            // permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Báo cáo sức khỏe',
              },
              {
                name: 'Danh sách báo cáo',
                active: true,
              },
            ],
          },
        },
        // HEALTH REPORT: END
        // CUSTOMER MANAGEMENT: BEGIN
        {
          path: 'active_account',
          name: 'active_account_list',
          component: () =>
            import('@/view/pages/active_account/AcctiveAccount.vue'),
          meta: {
            pageCode: PAGE_CODE.CUSTOMER_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Kích hoạt tài khoản',
              },
              {
                name: 'Danh sách tài khoản',
              },
              {
                name: 'Danh sách kích hoạt tài khoản',
                active: true,
              },
            ],
          },
        },
        {
          path: 'customer',
          name: 'customer',
          component: () => import('@/view/pages/customer/CustomerList'),
          meta: {
            breadcrumb: [
              {
                name: 'Khách hàng của tôi',
              },
              {
                name: 'Danh sách khách hàng',
              },
              {
                name: 'Danh sách khách hàng của tôi',
                active: true,
              },
            ],
          },
        },
        // CUSTOMER MANAGEMENT: END
        // COURSE: BEGIN
        {
          path: 'course',
          name: 'course',
          component: () => import('@/view/pages/course/course.vue'),
          meta: {
            breadcrumb: [
              {
                name: 'Khoá học',
                link: 'course',
                active: true,
              },
            ],
          },
        },
        {
          path: 'course/:id?',
          name: 'course_detail',
          props: true,
          component: () => import('@/view/pages/course/courseDetail.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Khoá học',
                link: 'course',
              },
              {
                name: 'Chi tiết khoá học',
                link: 'course_detail',
                active: true,
              },
            ],
          },
        },
        {
          path: 'module',
          name: 'module',
          component: () => import('@/view/pages/module/ModuleList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.LESSON_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chủ đề',
              },
              {
                name: 'Danh sách chủ đề',
              },
              {
                name: 'Danh sách chủ đề',
                active: true,
              },
            ],
          },
        },
        {
          path: 'lesson',
          name: 'lesson',
          component: () => import('@/view/pages/lesson/LessonList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.LESSON,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý bài học',
              },
              {
                name: 'Danh sách bài học',
              },
              {
                name: 'Danh sách bài học',
                active: true,
              },
            ],
          },
        },
        {
          path: 'lesson/create',
          name: 'lesson_create',
          component: () => import('@/view/pages/lesson/LessonEdit.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.LESSON,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý bài học',
                link: 'lesson',
              },
              {
                name: 'Thêm mới bài học',
                link: 'lesson_create',
              },
              {
                name: 'Tạo mới bài học',
                active: true,
              },
            ],
          },
        },
        {
          path: 'lesson/edit/:id',
          name: 'lesson_edit',
          component: () => import('@/view/pages/lesson/LessonEdit.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.LESSON,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý bài học',
                link: 'lesson',
              },
              {
                name: 'Chỉnh sửa bài học',
              },
              {
                name: 'Chỉnh sửa bài học',
                active: true,
              },
            ],
          },
        },
        {
          path: 'lesson/view/:id',
          name: 'lesson_view',
          component: () => import('@/view/pages/lesson/LessonDetail.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.LESSON,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý bài học',
                link: 'lesson',
              },
              {
                name: 'Chi tiết bài học',
              },
              {
                name: 'Chi tiết bài học',
                active: true,
              },
            ],
          },
        },
        // COURSE: END
        // LEVEL: BEGIN
        {
          path: 'level',
          name: 'level',
          component: () => import('@/view/pages/level/LevelList.vue'),
          meta: {
            pageCode: PAGE_CODE.LESSON_LEVEL,
            permissions: [PERMISSION_TYPE.VIEW],
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Quản lý cấp độ',
              },
              {
                name: 'Danh sách cấp độ',
              },
              {
                name: 'Danh sách cấp độ',
                active: true,
              },
            ],
          },
        },
        // LEVEL: END
        // LEVEL: BEGIN
        {
          path: 'voucher',
          name: 'voucher',
          component: () => import('@/view/pages/voucher/List.vue'),
          meta: {
            pageCode: PAGE_CODE.VOUCHERS,
            permissions: [PERMISSION_TYPE.VIEW],
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Quản lý Voucher',
              },
              {
                name: 'Danh sách Voucher',
              },
              {
                name: 'Danh sách Voucher',
                active: true,
              },
            ],
          },
        },
        {
          path: 'report1',
          name: 'report1',
          component: () => import('@/view/pages/Report/Report1.vue'),
          meta: {
            pageCode: PAGE_CODE.REPORT,
            permissions: [PERMISSION_TYPE.VIEW],
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh sách Report',
              },
              {
                name: 'Report',
              },
              {
                name: 'Danh sách Report',
                active: true,
              },
            ],
          },
        },
        {
          path: 'report2',
          name: 'report2',
          component: () => import('@/view/pages/Report/Report2.vue'),
          meta: {
            pageCode: PAGE_CODE.REPORT,
            permissions: [PERMISSION_TYPE.VIEW],
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh sách Report',
              },
              {
                name: 'Report',
              },
              {
                name: 'Danh sách Report',
                active: true,
              },
            ],
          },
        },
        {
          path: 'report3',
          name: 'report3',
          component: () => import('@/view/pages/Report/Report3.vue'),
          meta: {
            pageCode: PAGE_CODE.REPORT,
            permissions: [PERMISSION_TYPE.VIEW],
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh sách Report',
              },
              {
                name: 'Report',
              },
              {
                name: 'Danh sách Report',
                active: true,
              },
            ],
          },
        },
        {
          path: 'report4',
          name: 'report4',
          component: () => import('@/view/pages/Report/Report4.vue'),
          meta: {
            pageCode: PAGE_CODE.REPORT,
            permissions: [PERMISSION_TYPE.VIEW],
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Danh sách Report',
              },
              {
                name: 'Report',
              },
              {
                name: 'Danh sách Report',
                active: true,
              },
            ],
          },
        },
        // LEVEL: END
        // QUIZE: BEGIN
        {
          path: 'quize',
          name: 'quize',
          component: () => import('@/view/pages/quize/Quize.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.QUIZ,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý câu hỏi',
              },
              {
                name: 'Danh sách câu hỏi',
              },
              {
                name: 'Ngân hàng câu hỏi',
                active: true,
              },
            ],
          },
        },
        // QUIZE: END
        // COACHES & EXPERTS: BEGIN
        {
          path: 'coaches_experts',
          name: 'coaches_experts',
          component: () =>
            import('@/view/pages/coaches_experts/coaches_experts.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COACHES_EXPERTS,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Theo dõi từng khách hàng',
              },
              {
                name: 'Danh sách khách hàng',
              },
              {
                name: 'Dashboard khách hàng',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach/create',
          name: 'coach_create',
          component: () => import('@/view/pages/coach/CoachCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAINING_GROUP,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý nhóm huấn luyện',
                link: 'CoachList',
              },
              {
                name: 'Thêm mới nhóm huấn luyện',
              },
              {
                name: 'Thêm mới nhóm huấn luyện',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach/edit/:id',
          name: 'coach_edit',
          component: () => import('@/view/pages/coach/CoachUpdate.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAINING_GROUP,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý nhóm huấn luyện',
                link: 'CoachList',
              },
              {
                name: 'Chỉnh sửa nhóm huấn luyện',
              },
              {
                name: 'Chỉnh sửa nhóm huấn luyện',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach/:id',
          name: 'coach_detail',
          component: () => import('@/view/pages/coach/CoachDetail.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAINING_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý nhóm huấn luyện',
                link: 'CoachList',
              },
              {
                name: 'Chi tiết nhóm huấn luyện',
              },
              {
                name: 'Chi tiết nhóm huấn luyện',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach_customers',
          name: 'CoachCustomers',
          component: () => import('@/view/pages/group_dashboard/index.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MY_CUSTOMER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Khách hàng của tôi',
              },
              {
                name: 'Danh sách khách hàng',
              },
              {
                name: 'Danh sách khách hàng',
                active: true,
              },
            ],
          },
        },

        // COACHES & EXPERTS: END
        // COACHES CALENDAR: BEGIN
        {
          path: 'coaches_calendar',
          name: 'coaches_calendar',
          component: () =>
            import('@/view/pages/coaches_calendar/Coaches_Calendar.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COACHES_CALENDAR,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý đặt lịch',
              },
              {
                name: 'Danh sách đặt lịch',
                active: true,
              },
            ],
          },
        },

        // COACHES CALENDAR: END
        // COACH: BEGIN
        {
          path: 'coach',
          name: 'CoachList',
          component: () => import('@/view/pages/coach/CoachList.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAINING_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý nhóm huấn luyện',
              },
              {
                name: 'Danh sách nhóm huấn luyện',
              },
              {
                name: 'Danh sách nhóm huấn luyện',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coaches_experts/:id',
          name: 'coaches_experts_detail',
          component: () => import('@/view/pages/coaches_experts/detail.vue'),
        },
        // COACH: END
        // MOVEMENT ROUTE: BEGIN
        {
          path: 'movement_route',
          name: 'movement_route_list',
          component: () =>
            import('@/view/pages/movement_route/MovementRouteList.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.AGENDA,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý lộ trình',
              },
              {
                name: 'Danh sách lộ trình',
              },
              {
                name: 'Danh sách lộ trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'movement_route/detail/:id',
          name: 'movement_route_detail',
          component: () =>
            import('@/view/pages/movement_route/MovementRouteDetail.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.AGENDA,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý lộ trình',
                link: 'movement_route_list',
              },
              {
                name: 'Chi tiết lộ trình',
              },
              {
                name: 'Chi tiết lộ trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'agenda/detail/:id',
          name: 'agenda_detail',
          component: () =>
            import('@/view/pages/movement_route/OtherSchedule.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.AGENDA,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý lộ trình',
                link: 'movement_route_list',
              },
              {
                name: 'Chi tiết lộ trình',
              },
              {
                name: 'Chi tiết lộ trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'movement_route/detail/:id/:lessonId',
          name: 'movement_route_lesson_detail',
          component: () =>
            import('@/view/pages/movement_route/MovementRouteLessonDetail.vue'),
          props: (route) => ({
            id: route.params.id,
            lessonId: route.params.lessonId,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.AGENDA,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý lộ trình vận động',
                link: 'movement_route_list',
              },
              {
                name: 'Chi tiết lộ trình',
                link: 'movement_route_detail',
              },
              {
                name: 'Chi tiết bài tập',
              },
              {
                name: 'Chi tiết bài tập',
                active: true,
              },
            ],
          },
        },
        {
          path: 'movement_route/create/:id/:day',
          name: 'movement_route_lesson_create',
          component: () =>
            import('@/view/pages/movement_route/MovementRouteLessonEdit.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.AGENDA,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý lộ trình',
                link: 'movement_route_list',
              },
              {
                name: 'Chi tiết lộ trình',
                link: 'movement_route_detail',
              },
              {
                name: 'Tạo mới bài tập',
              },
              {
                name: 'Tạo mới bài tập',
                active: true,
              },
            ],
          },
        },
        {
          path: 'movement_route/edit/:id/:lessonId',
          name: 'movement_route_lesson_edit',
          component: () =>
            import('@/view/pages/movement_route/MovementRouteLessonEdit.vue'),

          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.AGENDA,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý lộ trình',
                link: 'movement_route_list',
              },
              {
                name: 'Chi tiết lộ trình',
                link: 'movement_route_detail',
              },
              {
                name: 'Chỉnh sửa bài tập',
              },
              {
                name: 'Chỉnh sửa bài tập',
                active: true,
              },
            ],
          },
        },
        // MOVEMENT ROUTE: END
        // CALENDAR: BEGIN
        {
          path: 'calendar',
          name: 'calendar_list',
          component: () => import('@/view/pages/calendar/CalendarList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CALENDAR,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Lịch làm việc',
              },
              {
                name: 'Danh sách lịch làm việc',
              },
              {
                name: 'Lịch làm việc',
                active: true,
              },
            ],
          },
        },
        // CALENDAR: END
        // ZOOM: BEGIN
        {
          path: 'zoom_video',
          name: 'zoom_login',
          component: () => import('@/view/pages/zoom_video/ZoomLogin.vue'),
          meta: {
            requiresAuth: true,
            // pageCode: PAGE_CODE.ZOOM_LOGIN,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Zoom Video',
              },
              {
                name: 'Preview',
                // active: true
              },
              {
                name: 'Preview',
                active: true,
              },
            ],
          },
        },
        // ZOOM : END
        // WEB OF COMMUNICATION: BEGIN
        {
          path: 'communication',
          name: 'communication_list',
          component: () =>
            import('@/view/pages/communication/communicationList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMUNICATION,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Thông báo',
              },
              {
                name: 'Danh sách thông báo',
              },
              {
                name: 'Danh sách thông báo',
                active: true,
              },
            ],
          },
        },
        {
          path: 'communication/detail/:id',
          name: 'communication_detail',
          component: () =>
            import('@/view/pages/communication/communicationDetail.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMUNICATION,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Thông báo',
                link: 'communication_list',
              },
              {
                name: 'Xem chi tiết thông báo',
              },
              {
                detailName: 'Xem chi tiết thông báo',
                active: true,
              },
            ],
          },
        },
        {
          path: 'communication/:form_type/:id?',
          name: 'communication_create',
          component: () =>
            import('@/view/pages/communication/communicationForm.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMUNICATION,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Thông báo',
                link: 'communication_list',
              },
              {
                createName: 'Thiết lập thông báo mới',
                editName: 'Chỉnh sửa thông báo',
              },
              {
                createName: 'Thiết lập thông báo mới',
                editName: 'Chỉnh sửa thông báo',
                active: true,
              },
            ],
          },
        },
        // {
        //   path: 'communication/:form_type/:id?',
        //   name: 'communication_update',
        //   component: () =>
        //     import('@/view/pages/communication/communicationForm.vue'),
        //   meta: {
        //     breadcrumb: [
        //       {
        //         name: 'Cổng giao tiếp',
        //         link: 'communication_list',
        //       },
        //       {
        //         createName: 'Thiết lập thông báo mới',
        //         editName: 'Chỉnh sửa thông báo',
        //         link: 'communication_create',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        // WEB OF COMMUNICATION: END
        // SURVEY: BEGIN
        {
          path: 'survey',
          name: 'survey_list',
          component: () => import('@/view/pages/survey/surveyList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khảo sát',
              },
              {
                name: 'Danh sách khảo sát',
              },
              {
                name: 'Danh sách khảo sát',
                active: true,
              },
            ],
          },
        },
        {
          path: 'survey/create',
          name: 'survey_create',
          component: () => import('@/view/pages/survey/surveyCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý khảo sát',
                link: 'survey_list',
              },
              {
                name: 'Thêm mới khảo sát',
              },
              {
                name: 'Tạo khảo sát mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'survey/:id',
          name: 'survey_detail',
          component: () => import('@/view/pages/survey/surveyDetail.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khảo sát',
                link: 'survey_list',
              },
              {
                name: 'Chi tiết khảo sát',
              },
              {
                name: 'Chi tiết khảo sát',
                active: true,
              },
            ],
          },
        },
        {
          path: 'survey/edit/:id',
          name: 'survey_edit',
          component: () => import('@/view/pages/survey/surveyEdit.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý khảo sát',
                link: 'survey_list',
              },
              {
                name: 'Chỉnh sửa khảo sát',
              },
              {
                name: 'Chỉnh sửa khảo sát',
                active: true,
              },
            ],
          },
        },
        // SURVEY: END
        // SURVEY_QUIZE: BEGIN
        {
          path: 'survey_quize',
          name: 'survey_quize_list',
          component: () =>
            import('@/view/pages/survey_quize/surveyQuizeList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý câu hỏi',
                link: 'survey_quize_list',
              },
              {
                name: 'Danh sách bộ câu hỏi',
              },
              {
                name: 'Bộ câu hỏi',
                active: true,
              },
            ],
          },
        },
        {
          path: 'survey_quize/create',
          name: 'survey_quize_create',
          component: () =>
            import('@/view/pages/survey_quize/surveyQuizeCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý bộ câu hỏi',
                link: 'survey_quize_list',
              },
              {
                name: 'Tạo mới bộ câu hỏi',
              },
              {
                name: 'Tạo mới bộ câu hỏi',
                active: true,
              },
            ],
          },
        },
        {
          path: 'survey_quize/:id',
          name: 'survey_quize_detail',
          component: () =>
            import('@/view/pages/survey_quize/surveyQuizeDetail.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý bộ câu hỏi',
                link: 'survey_quize_list',
              },
              {
                name: 'Chi tiết bộ câu hỏi',
              },
              {
                name: 'Chi tiết bộ câu hỏi',
                active: true,
              },
            ],
          },
        },
        {
          path: 'survey_quize/edit/:id',
          name: 'survey_quize_edit',
          component: () =>
            import('@/view/pages/survey_quize/surveyQuizeEdit.vue'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý bộ câu hỏi',
                link: 'survey_quize_list',
              },
              {
                name: 'Chỉnh sửa bộ câu hỏi',
              },
              {
                name: 'Chỉnh sửa bộ câu hỏi',
                active: true,
              },
            ],
          },
        },
        // SURVEY_QUIZE: END
        // SURVEY_RÉULT: BEGIN
        {
          path: 'survey_result',
          name: 'survey_result_list',
          component: () =>
            import('@/view/pages/survey_result/surveyResultList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khảo sát',
                link: 'survey_result_list',
              },
              {
                name: 'Kết quả khảo sát',
              },
              {
                name: 'Danh sách kết quả khảo sát',
                active: true,
              },
            ],
          },
        },
        // SURVEY_RÉULT: END
        // LESSON_RESULT: BEGIN
        {
          path: 'lesson_result',
          name: 'lesson_result_list',
          component: () =>
            import('@/view/pages/lesson_result/lessonResultList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SURVEY_QUESTION_GROUP,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khảo sát',
                link: 'survey_result_list',
              },
              {
                name: 'Mức độ tương tác',
                active: true,
              },
            ],
          },
        },
        // LESSON_RESULT: END
        // SYSTEM PARAMETER: BEGIN
        {
          path: 'system_parameter',
          name: 'system_parameter',
          component: () =>
            import('@/view/pages/system_parameter/systemParameterList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Tham số hệ thống',
              },
              {
                name: 'Danh sách tham số hệ thống',
              },
              {
                name: 'Danh sách tham số hệ thống',
                active: true,
              },
            ],
          },
        },
        // SYSTEM PARAMETER: END
        // AI MODEL SETTINGS: BEGIN
        {
          path: 'ai_model_settings',
          name: 'ai_model_settings',
          component: () => import('@/view/pages/ai_model_settings/AiModelSettings.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Cài đặt',
              },
              {
                name: 'Model AI',
                active: true,
              },
            ],
          },
        },
        // AI MODEL SETTINGS: END
        // AI QUALITY: BEGIN
        {
          path: 'ai_quality',
          name: 'ai_quality',
          component: () => import('@/view/pages/ai_quality/AiQuality.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Cài đặt',
              },
              {
                name: 'Chất lượng AI',
                active: true,
              },
            ],
          },
        },
        // AI QUALITY: END
        // DEV NOTE: BEGIN
        {
          path: 'dev_note',
          name: 'dev_note',
          component: () =>
            import('@/view/pages/dev_note/DevNote.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.DEV_NOTE,
            permissions: [PERMISSION_TYPE.VIEW, PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Cài đặt',
              },
              {
                name: 'DevNote',
              },
              {
                name: 'Ghi chú phát triển',
                active: true,
              },
            ],
          },
        },
        // DEV NOTE: END
        // GLUCOSE: BEGIN
        {
          path: 'glucose',
          name: 'glucose_list',
          component: () => import('@/view/pages/glucose/glucoseList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.GLUCOSE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Ngưỡng đường huyết',
              },
              {
                name: 'Danh sách ngưỡng đường huyết',
              },
              {
                name: 'Danh sách ngưỡng đường huyết',
                active: true,
              },
            ],
          },
        },
        // GLUCOSE: END
        // EXERCISE: BEGIN
        {
          path: 'exercise',
          name: 'exercise_list',
          component: () => import('@/view/pages/exercise/exerciseList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.EXERCISE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý vận động',
              },
              {
                name: 'Danh sách vận động',
              },
              {
                name: 'Danh sách vận động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'exercise/:form_type/:id?',
          name: 'exercise_detail',
          props: true,
          component: () => import('@/view/pages/exercise/exerciseDetail.vue'),
          meta: {
            pageCode: PAGE_CODE.EXERCISE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
          },
        },
        // EXERCISE: END
        // FOOD: BEGIN
        {
          path: 'food',
          name: 'food_list',
          component: () => import('@/view/pages/food/foodList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.FOOD_CATEGORY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý món ăn',
              },
              {
                name: 'Danh sách món ăn',
              },
              {
                name: 'Danh sách món ăn',
                active: true,
              },
            ],
          },
        },
        {
          path: 'food/:form_type/:id?',
          name: 'food_detail',
          props: true,
          component: () => import('@/view/pages/food/foodDetail.vue'),
          meta: {
            pageCode: PAGE_CODE.FOOD_CATEGORY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
          },
        },
        // FOOD: END
        // MENU: BEGIN
        {
          path: 'menu',
          name: 'menu_list',
          component: () => import('@/view/pages/menu/menuList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.FOOD_MENU,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý thực đơn mẫu',
              },
              {
                name: 'Danh sách thực đơn mẫu',
              },
              {
                name: 'Danh sách thực đơn mẫu',
                active: true,
              },
            ],
          },
        },
        {
          path: 'menu/detail/:id',
          name: 'menu_detail',
          props: true,
          component: () => import('@/view/pages/menu/menuDetail.vue'),
          meta: {
            pageCode: PAGE_CODE.FOOD_MENU,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý thực đơn mẫu',
                link: 'menu_list',
              },
              {
                name: 'Chi tiết thực đơn mẫu',
              },
              {
                name: 'Chi tiết thực đơn mẫu',
                active: true,
              },
            ],
          },
        },
        {
          path: 'menu/edit/:id',
          name: 'menu_edit',
          props: (route) => ({
            id: route.params.id,
          }),
          component: () => import('@/view/pages/menu/menuEdit.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.FOOD_MENU,
            permissions: [PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý thực đơn mẫu',
                link: 'menu_list',
              },
              {
                name: 'Chỉnh sửa thực đơn',
              },
              {
                name: 'Chỉnh sửa thực đơn',
                active: true,
              },
            ],
          },
        },
        // MENU: END
        // WEIGHT: BEGIN
        {
          path: 'weight',
          name: 'weight_list',
          component: () =>
            import('@/view/pages/bmi_and_weight/bmiAndWeightList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BMI,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Ngưỡng BMI / Cân nặng',
              },
              {
                name: 'Danh sách ngưỡng BMI / Cân nặng',
              },
              {
                name: 'Ngưỡng BMI / Cân nặng',
                active: true,
              },
            ],
          },
        },
        // WEIGHT: END
        // FEELING: BEGIN
        {
          path: 'feeling',
          name: 'feeling_list',
          component: () => import('@/view/pages/feeling/feeling.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.EMOTION,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Cảm xúc',
              },
              {
                name: 'Danh sách cảm xúc',
              },
              {
                name: 'Cảm xúc',
                active: true,
              },
            ],
          },
        },
        // FEELING: END
        // TIME FRAME OF OPERATION : BEGIN
        {
          path: 'time_frame_of_operation',
          name: 'time_frame_of_operation_list',
          component: () =>
            import(
              '@/view/pages/time_frame_of_operation/timeFrameOfOperationList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TIME_FRAME,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Khung giờ và thời gian hoạt động',
              },
              {
                name: 'Danh sách khung giờ và thời gian hoạt động',
              },
              {
                name: 'Khung giờ và thời gian hoạt động',
                active: true,
              },
            ],
          },
        },
        // TIME FRAME OF OPERATION : END
        // CONTENT NOTIFICATION OF KPIS: BEGIN
        {
          path: 'content',
          name: 'content',
          component: () => import('@/view/pages/content/content.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COMMON_CONFIGURE_TASK_CONTENT,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản trị nội dung',
              },
              {
                name: 'Danh sách nội dung',
              },
              {
                name: 'Quản trị nội dung',
                active: true,
              },
            ],
          },
        },
        // CONTENT NOTIFICATION OF KPIS: END
        // PROFILE PAGE: BEGIN
        {
          path: 'profile',
          name: 'profile',
          component: () => import('@/view/pages/profile/index.vue'),
          meta: {
            breadcrumb: [
              {
                name: 'Profile',
                link: 'profile',
                active: true,
              },
            ],
          },
        },
        // COURSE: BEGIN
        {
          path: 'course',
          name: 'course',
          component: () => import('@/view/pages/course/course.vue'),
          meta: {
            breadcrumb: [
              {
                name: 'Khoá học',
                link: 'course',
                active: true,
              },
            ],
          },
        },
        {
          path: 'course/:id?',
          name: 'course_detail',
          props: true,
          component: () => import('@/view/pages/course/courseDetail.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: 'Khoá học',
                link: 'course',
              },
              {
                name: 'Chi tiết khoá học',
                link: 'course_detail',
                active: true,
              },
            ],
          },
        },
        // PROFILE PAGE: END
        // FEATURED ARTICLE: BEGIN
        {
          path: 'article',
          name: 'article',
          component: () => import('@/view/pages/article/article.vue'),
          meta: {
            pageCode: PAGE_CODE.LEARNING_POST,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Bài viết nổi bật',
              },
              {
                name: 'Danh sách bài viết',
              },
              {
                name: 'Bài viết nổi bật',
                active: true,
              },
            ],
          },
        },
        // FEATURED ARTICLE: END
        // EVENT: BEGIN
        {
          path: 'event',
          name: 'event',
          component: () => import('@/view/pages/event/event.vue'),
          meta: {
            pageCode: PAGE_CODE.LEARNING_POST,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Sự kiện',
              },
              {
                name: 'Danh sách sự kiện',
              },
              {
                name: 'Sự kiện',
                active: true,
              },
            ],
          },
        },
        // EVENT: END
        // USER GUIDE : BEGIN
        {
          path: 'user_guide',
          name: 'user_guide',
          component: () => import('@/view/pages/guide/guide.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROFILE_INSTRUCTION,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Hướng dẫn sử dụng',
              },
              {
                name: 'Danh sách hướng dẫn sử dụng',
              },
              {
                name: 'Hướng dẫn sử dụng',
                active: true,
              },
            ],
          },
        },
        // USER GUIDE: END
        // QUESTION RESPONSE : BEGIN
        {
          path: 'question_response',
          name: 'question_response',
          component: () =>
            import('@/view/pages/question_response/QuestionResponseList.vue'),
          meta: {
            pageCode: PAGE_CODE.QUESTION,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Hỏi đáp chuyên gia',
              },
              {
                name: 'Danh sách câu hỏi',
              },
              {
                name: 'Danh sách câu hỏi',
                active: true,
              },
            ],
          },
        },
        // QUESTION RESPONSE: END
        // CUSTOMER CENTER
        {
          path: 'customer_center',
          name: 'customer_center',
          component: () =>
            import('@/view/pages/customer_center/CustomerCenterList'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_CENTER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khách hàng trung tâm',
              },
              {
                name: 'Danh sách khách hàng trung tâm',
              },
              {
                name: 'Danh sách khách hàng trung tâm',
                active: true,
              },
            ],
          },
        },
        // Courses: BEGIN
        {
          path: 'courses',
          name: 'courses_list',
          component: () => import('@/view/pages/courses/CoursesList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COURSES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Khách hàng',
              },
              {
                name: 'Danh sách khóa học',
              },
              {
                name: 'Danh sách khóa học',
                active: true,
              },
            ],
          },
        },
        {
          path: 'courses',
          name: 'courses_list_filter',
          component: () => import('@/view/pages/courses/CoursesListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COURSES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Courses',
              },
              {
                name: 'Danh sách Courses',
              },
              {
                name: 'Danh sách courses',
                active: true,
              },
            ],
          },
        },
        {
          path: 'courses/create',
          name: 'courses_create',
          // props: {
          // default: true,
          // form_type: "create" // Set props to pass to the component
          // },
          props: true,
          component: () => import('@/view/pages/courses/CoursesCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COURSES,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý Khách hàng',
                link: 'courses_list',
              },
              {
                name: 'Thêm mới',
              },
              {
                name: 'Thêm mới ',
                link: 'courses_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'courses/:id?',
          name: 'courses_view',
          props: true,
          component: () => import('@/view/pages/courses/CoursesView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COURSES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khóa học',
                link: 'courses_list',
              },
              {
                name: 'Chi tiết khóa học',
              },
              {
                name: 'Chi tiết khóa học',
                active: true,
              },
            ],
          },
        },
        {
          path: 'courses/:form_type/:id?',
          name: 'courses_edit',
          props: true,
          component: () => import('@/view/pages/courses/CoursesUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.COURSES,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Quản lý Khách hàng',
                link: 'courses_list',
              },
              {
                name: 'Chỉnh sửa',
              },
              {
                name: 'Chỉnh sửa ',
                link: 'courses_create',
                active: true,
              },
            ],
          },
        },
        // Courses: END
        // CustomerReceives: BEGIN
        {
          path: 'customer_receives',
          name: 'customer_receives_list',
          component: () =>
            import('@/view/pages/customer_receives/CustomerReceivesList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_RECEIVES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý khách hàng',
              },
              {
                name: 'Danh sách tiếp nhận',
              },
              {
                name: 'Danh sách tiếp nhận',
                active: true,
              },
            ],
          },
        },
        {
          path: 'customer_receives/:id?',
          name: 'customer_receives_view',
          props: true,
          component: () =>
            import('@/view/pages/customer_receives/CustomerReceivesView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_RECEIVES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý CustomerReceives',
                link: 'customer_receives_list',
              },
              {
                name: 'Chi tiết CustomerReceives',
              },
              {
                name: 'Chi tiết CustomerReceives',
                active: true,
              },
            ],
          },
        },
        {
          path: 'dashboard_tracking',
          name: 'dashboard_tracking_list',
          props: true,
          component: () =>
            import('@/view/pages/dashboard_tracking/DashboardTracking.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.DASHBOARD_TRACKING,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Tracking Dashboard',
                link: 'dashboard_tracking_list',
              },
              {
                name: 'Chi tiết Tracking Dashboard',
              },
              {
                name: 'Chi tiết Tracking Dashboard',
                active: true,
              },
            ],
          },
        },
        // CustomerReceives: END
        // MessageTemplates: BEGIN
        {
          path: 'message_templates',
          name: 'message_templates_list',
          component: () =>
            import('@/view/pages/message_templates/MessageTemplatesList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý template tin nhắn',
              },
              {
                name: 'Danh sách template tin nhắn',
              },
              {
                name: 'Danh sách template tin nhắn',
                active: true,
              },
            ],
          },
        },
        {
          path: 'zalo_chat_history',
          name: 'zalo_chat_history_list',
          component: () =>
            import('@/view/pages/courses/components/ZaloChatHistory.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ZALO_CHAT_HISTORY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý tin nhắn nhóm zalo',
              },
              {
                name: 'Danh sách tin nhắn nhóm zalo',
              },
              {
                name: 'Danh sách tin nhắn nhóm zalo',
                active: true,
              },
            ],
          },
        },
        {
          path: 'reminder_tracking',
          name: 'reminder_tracking_list',
          component: () =>
            import('@/view/pages/reminder_tracking/ReminderTrackingList.vue'),
          meta: {
            requiresAuth: true,
            // Endpoint /ReminderApproval/schedule bên BE cũng gác bằng quyền
            // ViewUserPackage, giữ trùng để không có màn hình mở được mà gọi API bị chặn.
            pageCode: PAGE_CODE.USER_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
              },
              {
                name: 'Theo dõi nhắc nhở',
              },
              {
                name: 'Theo dõi nhắc nhở',
                active: true,
              },
            ],
          },
        },
        {
          path: 'decision_ai_coach',
          name: 'decision_ai_coach_list',
          component: () =>
            import('@/view/pages/decision_ai_coach/DecisionAiCoachList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.DECISION_AI_COACH,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Nhóm tính năng thử nghiệm',
              },
              {
                name: 'Decision AI Coach',
              },
              {
                name: 'Decision AI Coach',
                active: true,
              },
            ],
          },
        },
        {
          path: 'dashboard_doctor',
          name: 'dashboard_doctor_view',
          component: () =>
            import("@/view/pages/dashboard_doctor/DashboardDoctorView.vue"),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MESSAGE_TEMPLATES, // Sửa thành PAGE_CODE phù hợp
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Dashboard',
                link: 'dashboard_doctor_view',
              },
              {
                name: 'Bệnh nhân',
                active: true,
              },
            ],
          },
        },
        {
          path: 'dashboard_doctor_his',
          name: 'dashboard_doctor_his',
          component: () =>
            import("@/view/pages/dashboard_doctor/DashboardDoctorHis.vue"),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.DASHBOARD_DOCTOR_HIS,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Tổng quan tình trạng sức khỏe và các chỉ số bệnh lý',
                link: 'dashboard_doctor_his',
              },
              {
                name: 'Hồ sơ bệnh nhân',
                active: true,
              },
            ],
          },
        },
        {
          path: 'message_templates',
          name: 'message_templates_list_filter',
          component: () =>
            import(
              '@/view/pages/message_templates/MessageTemplatesListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý MessageTemplates',
              },
              {
                name: 'Danh sách MessageTemplates',
              },
              {
                name: 'Danh sách messageTemplates',
                active: true,
              },
            ],
          },
        },
        // {
        //   path: 'dashboard_doctor',
        //   name: 'dashboard_doctor_view',
        //   component: () =>
        //     import('@/view/pages/dashboard_doctor/DashboardDoctorView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
        //     permissions: [PERMISSION_TYPE.VIEW],
        //     breadcrumb: [
        //       {
        //         name: 'Quản lý Dashboard',
        //         link: 'dashboard_doctor_view',
        //       },
        //       {
        //         name: 'Bệnh nhân',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        {
          path: 'message_templates/create',
          name: 'message_templates_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/message_templates/MessageTemplatesCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý MessageTemplates',
                link: 'message_templates_list',
              },
              {
                name: 'Thêm mới MessageTemplates',
              },
              {
                name: 'Tạo mới MessageTemplates',
                link: 'message_templates_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'message_templates/:id?',
          name: 'message_templates_view',
          props: true,
          component: () =>
            import('@/view/pages/message_templates/MessageTemplatesView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý MessageTemplates',
                link: 'message_templates_list',
              },
              {
                name: 'Chi tiết MessageTemplates',
              },
              {
                name: 'Chi tiết MessageTemplates',
                active: true,
              },
            ],
          },
        },
        {
          path: 'message_templates/:form_type/:id?',
          name: 'message_templates_edit',
          props: true,
          component: () =>
            import('@/view/pages/message_templates/MessageTemplatesUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.MESSAGE_TEMPLATES,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục MessageTemplates',
                link: 'message_templates_list',
              },
              {
                createName: 'Thêm mới MessageTemplates',
                editName: 'Chỉnh sửa MessageTemplates',
                link: 'message_templates_edit',
                active: true,
              },
            ],
          },
        },
        // ServicePackage: BEGIN
        {
          path: 'service_package',
          name: 'service_package_list',
          component: () =>
            import('@/view/pages/service_package/ServicePackageList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Gói dịch vụ',
              },
              {
                name: 'Danh sách Gói dịch vụ',
              },
              {
                name: 'Danh sách Gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package',
          name: 'service_package_list_filter',
          component: () =>
            import('@/view/pages/service_package/ServicePackageListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý gói dịch vụ',
              },
              {
                name: 'Danh sách gói dịch vụ',
              },
              {
                name: 'Danh sách gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package/create',
          name: 'service_package_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/service_package/ServicePackageUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý Gói dịch vụ',
                link: 'service_package_list',
              },
              {
                name: 'Thêm mới Gói dịch vụ',
              },
              {
                name: 'Tạo mới Gói dịch vụ',
                link: 'service_package_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package/:id?',
          name: 'service_package_view',
          props: true,
          component: () =>
            import('@/view/pages/service_package/ServicePackageView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý gói dịch vụ',
                link: 'service_package_list',
              },
              {
                name: 'Chi tiết gói dịch vụ',
              },
              {
                name: 'Chi tiết gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package/:form_type/:id?',
          name: 'service_package_edit',
          props: true,
          component: () =>
            import('@/view/pages/service_package/ServicePackageUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục Gói dịch vụ',
                link: 'service_package_list',
              },
              {
                name: 'Thêm mới Gói dịch vụ',
                link: 'service_package_edit',
              },
              {
                createName: 'Thêm mới Gói dịch vụ',
                editName: 'Chỉnh sửa ServicePackage',
                link: 'service_package_edit',
                active: true,
              },
            ],
          },
        },
        // ServicePackage: END
        // ServicePackageProgram: BEGIN
        {
          path: 'service_package_program',
          name: 'service_package_program_list',
          component: () =>
            import(
              '@/view/pages/service_package_program/ServicePackageProgramList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE_PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chương trình gói dịch vụ',
              },
              {
                name: 'Danh sách  chương trình gói dịch vụ',
              },
              {
                name: 'Danh sách  chương trình gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package_program',
          name: 'service_package_program_list_filter',
          component: () =>
            import(
              '@/view/pages/service_package_program/ServicePackageProgramListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE_PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý gói chương trình dịch vụ',
              },
              {
                name: 'Danh sách gói chương trình dịch vụ',
              },
              {
                name: 'Danh sách gói chương trình dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package_program/create',
          name: 'service_package_program_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/service_package_program/ServicePackageProgramCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE_PROGRAM,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý gói chương trình dịch vụ',
                link: 'service_package_program_list',
              },
              {
                name: 'Thêm mới gói chương trình dịch vụ',
              },
              {
                name: 'Tạo mới gói chương trình dịch vụ',
                link: 'service_package_program_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package_program/:id?',
          name: 'service_package_program_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/service_package_program/ServicePackageProgramView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE_PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý gói chương trình dịch vụ',
                link: 'service_package_program_list',
              },
              {
                name: 'Chi tiết gói chương trình dịch vụ',
              },
              {
                name: 'Chi tiết gói chương trình dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service_package_program/:form_type/:id?',
          name: 'service_package_program_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/service_package_program/ServicePackageProgramUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.SERVICE_PACKAGE_PROGRAM,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục ServicePackageProgram',
                link: 'service_package_program_list',
              },
              {
                createName: 'Thêm mới ServicePackageProgram',
                editName: 'Chỉnh sửa ServicePackageProgram',
                link: 'service_package_program_edit',
                active: true,
              },
            ],
          },
        },
        // ServicePackageProgram: END
        // UserPackage: BEGIN
        {
          path: 'user_package',
          name: 'user_package_list',
          component: () =>
            import('@/view/pages/user_package/UserPackageList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.USER_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách người dùng gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_package',
          name: 'user_package_list_filter',
          component: () =>
            import('@/view/pages/user_package/UserPackageListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.USER_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách userPackage',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_package/create',
          name: 'user_package_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/user_package/UserPackageUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.USER_PACKAGE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
                link: 'user_package_list',
              },
              {
                name: 'Thêm mới người dùng gói dịch vụ',
              },
              {
                name: 'Tạo mới người dùng gói dịch vụ',
                link: 'user_package_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_package/:id?',
          name: 'user_package_view',
          props: true,
          component: () =>
            import('@/view/pages/user_package/UserPackageView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.USER_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
                link: 'user_package_list',
              },
              {
                name: 'Chi tiết người dùng gói dịch vụ',
              },
              {
                name: 'Chi tiết người dùng gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'user_package/:form_type/:id?',
          name: 'user_package_edit',
          props: true,
          component: () =>
            import('@/view/pages/user_package/UserPackageUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.USER_PACKAGE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục người dùng gói dịch vụ',
                link: 'user_package_list',
              },
              {
                createName: 'Thêm mới người dùng gói dịch vụ',
                editName: 'Chỉnh sửa người dùng gói dịch vụ',
                link: 'user_package_edit',
                active: true,
              },
            ],
          },
        },
        // UserPackage: END
        // ProgramActivityLevel: BEGIN
        {
          path: 'program_activity_level',
          name: 'program_activity_level_list',
          component: () =>
            import(
              '@/view/pages/program_activity_level/ProgramActivityLevelList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_LEVEL,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý cấp độ hoạt động',
              },
              {
                name: 'Danh sách cấp độ hoạt động',
              },
              {
                name: 'Danh sách cấp độ hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_level',
          name: 'program_activity_level_list_filter',
          component: () =>
            import(
              '@/view/pages/program_activity_level/ProgramActivityLevelListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_LEVEL,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý cấp độ hoạt động',
              },
              {
                name: 'Danh sách cấp độ hoạt động',
              },
              {
                name: 'Danh sách cấp độ hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_level/create',
          name: 'program_activity_level_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/program_activity_level/ProgramActivityLevelUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_LEVEL,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý cấp độ hoạt động',
                link: 'program_activity_level_list',
              },
              {
                name: 'Thêm mới cấp độ hoạt động',
              },
              {
                name: 'Tạo mới cấp độ hoạt động',
                link: 'program_activity_level_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_level/:id?',
          name: 'program_activity_level_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_activity_level/ProgramActivityLevelView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_LEVEL,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý cấp độ hoạt động',
                link: 'program_activity_level_list',
              },
              {
                name: 'Chi tiết cấp độ hoạt động',
              },
              {
                name: 'Chi tiết cấp độ hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_level/:form_type/:id?',
          name: 'program_activity_level_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_activity_level/ProgramActivityLevelUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_LEVEL,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục cấp độ hoạt động',
                link: 'program_activity_level_list',
              },
              {
                createName: 'Thêm mới cấp độ hoạt động',
                editName: 'Chỉnh sửa cấp độ hoạt động',
                link: 'program_activity_level_edit',
                active: true,
              },
            ],
          },
        },
        // ProgramActivityLevel: END
        // ProgramActivity: BEGIN
        {
          path: 'program_activity',
          name: 'program_activity_list',
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity',
          name: 'program_activity_list_filter',
          component: () =>
            import(
              '@/view/pages/program_activity/ProgramActivityListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity/create',
          name: 'program_activity_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
                link: 'program_activity_list',
              },
              {
                name: 'Thêm mới hoạt động',
              },
              {
                name: 'Tạo mới hoạt động',
                link: 'program_activity_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity/:id?',
          name: 'program_activity_view',
          props: true,
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
                link: 'program_activity_list',
              },
              {
                name: 'Chi tiết hoạt động',
              },
              {
                name: 'Chi tiết hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity/:form_type/:id?',
          name: 'program_activity_edit',
          props: true,
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục hoạt động',
                link: 'program_activity_list',
              },
              {
                createName: 'Thêm mới hoạt động',
                editName: 'Chỉnh sửa hoạt động',
                link: 'program_activity_edit',
                active: true,
              },
            ],
          },
        },
        // ProgramActivity: END
        // ActivityType: BEGIN
        {
          path: 'activity_type',
          name: 'activity_type_list',
          component: () =>
            import('@/view/pages/activity_type/ActivityTypeList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TYPE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý loại hoạt động',
              },
              {
                name: 'Danh sách loại hoạt động',
              },
              {
                name: 'Danh sách loại hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_type',
          name: 'activity_type_list_filter',
          component: () =>
            import('@/view/pages/activity_type/ActivityTypeListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TYPE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý loại hoạt động',
              },
              {
                name: 'Danh sách loại hoạt động',
              },
              {
                name: 'Danh sách loại hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_type/create',
          name: 'activity_type_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/activity_type/ActivityTypeUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TYPE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý loại hoạt động',
                link: 'activity_type_list',
              },
              {
                name: 'Thêm mới loại hoạt động',
              },
              {
                name: 'Tạo mới loại hoạt động',
                link: 'activity_type_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_type/:id?',
          name: 'activity_type_view',
          props: true,
          component: () =>
            import('@/view/pages/activity_type/ActivityTypeView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TYPE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý loại hoạt động',
                link: 'activity_type_list',
              },
              {
                name: 'Chi tiết loại hoạt động',
              },
              {
                name: 'Chi tiết loại hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_type/:form_type/:id?',
          name: 'activity_type_edit',
          props: true,
          component: () =>
            import('@/view/pages/activity_type/ActivityTypeUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TYPE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục loại hoạt động',
                link: 'activity_type_list',
              },
              {
                createName: 'Thêm mới loại hoạt động',
                editName: 'Chỉnh sửa loại hoạt động',
                link: 'activity_type_edit',
                active: true,
              },
            ],
          },
        },
        // ActivityType: END
        // ProgramActivityReminder: BEGIN
        {
          path: 'program_activity_reminder',
          name: 'program_activity_reminder_list',
          component: () =>
            import(
              '@/view/pages/program_activity_reminder/ProgramActivityReminderList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý nhắc nhở hoạt động',
              },
              {
                name: 'Danh sách nhắc nhở hoạt động',
              },
              {
                name: 'Danh sách nhắc nhở hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_reminder',
          name: 'program_activity_reminder_list_filter',
          component: () =>
            import(
              '@/view/pages/program_activity_reminder/ProgramActivityReminderListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý nhắc nhở hoạt động',
              },
              {
                name: 'Danh sách nhắc nhở hoạt động',
              },
              {
                name: 'Danh sách activityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_reminder/create',
          name: 'program_activity_reminder_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/program_activity_reminder/ProgramActivityReminderCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý nhắc nhở hoạt động',
                link: 'program_activity_reminder_list',
              },
              {
                name: 'Thêm mới nhắc nhở hoạt động',
              },
              {
                name: 'Tạo mới nhắc nhở hoạt động',
                link: 'program_activity_reminder_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_reminder/:id?',
          name: 'program_activity_reminder_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_activity_reminder/ProgramActivityReminderView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý nhắc nhở hoạt động',
                link: 'program_activity_reminder_list',
              },
              {
                name: 'Chi tiết nhắc nhở hoạt động',
              },
              {
                name: 'Chi tiết nhắc nhở hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity_reminder/:form_type/:id?',
          name: 'program_activity_reminder_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_activity_reminder/ProgramActivityReminderUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục nhắc nhở hoạt động',
                link: 'program_activity_reminder_list',
              },
              {
                createName: 'Thêm mới nhắc nhở hoạt động',
                editName: 'Chỉnh sửa nhắc nhở hoạt động',
                link: 'program_activity_reminder_edit',
                active: true,
              },
            ],
          },
        },
        // ProgramActivityReminder: END
        // ActivityTopic: BEGIN
        {
          path: 'activity_topic',
          name: 'activity_topic_list',
          component: () =>
            import('@/view/pages/activity_topic/ActivityTopicList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TOPIC,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chủ đề',
              },
              {
                name: 'Danh sách chủ đề',
              },
              {
                name: 'Danh sách chủ đề',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_topic',
          name: 'activity_topic_list_filter',
          component: () =>
            import('@/view/pages/activity_topic/ActivityTopicListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TOPIC,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chủ đề',
              },
              {
                name: 'Danh sách chủ đề',
              },
              {
                name: 'Danh sách chủ đề',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_topic/create',
          name: 'activity_topic_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/activity_topic/ActivityTopicUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TOPIC,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý chủ đề',
                link: 'activity_topic_list',
              },
              {
                name: 'Thêm mới chủ đề',
              },
              {
                name: 'Tạo mới chủ đề',
                link: 'activity_topic_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_topic/:id?',
          name: 'activity_topic_view',
          props: true,
          component: () =>
            import('@/view/pages/activity_topic/ActivityTopicView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TOPIC,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chủ đề',
                link: 'activity_topic_list',
              },
              {
                name: 'Chi tiết chủ đề',
              },
              {
                name: 'Chi tiết chủ đề',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_topic/:form_type/:id?',
          name: 'activity_topic_edit',
          props: true,
          component: () =>
            import('@/view/pages/activity_topic/ActivityTopicUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_TOPIC,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục chủ đề',
                link: 'activity_topic_list',
              },
              {
                createName: 'Thêm mới chủ đề',
                editName: 'Chỉnh sửa chủ đề',
                link: 'activity_topic_edit',
                active: true,
              },
            ],
          },
        },
        // ActivityTopic: END
        // ActivityDisplayDay: BEGIN
        {
          path: 'activity_display_day',
          name: 'activity_display_day_list',
          component: () =>
            import(
              '@/view/pages/activity_display_day/ActivityDisplayDayList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_DISPLAY_DAY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý thời gian hiển thị',
              },
              {
                name: 'Danh sách thời gian hiển thị',
              },
              {
                name: 'Danh sách thời gian hiển thị',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_display_day',
          name: 'activity_display_day_list_filter',
          component: () =>
            import(
              '@/view/pages/activity_display_day/ActivityDisplayDayListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_DISPLAY_DAY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý thời gian hiển thị',
              },
              {
                name: 'Danh sách thời gian hiển thị',
              },
              {
                name: 'Danh sách thời gian hiển thị',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_display_day/create',
          name: 'activity_display_day_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/activity_display_day/ActivityDisplayDayUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_DISPLAY_DAY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý thời gian hiển thị',
                link: 'activity_display_day_list',
              },
              {
                name: 'Thêm mới thời gian hiển thị',
              },
              {
                name: 'Tạo mới thời gian hiển thị',
                link: 'activity_display_day_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_display_day/:id?',
          name: 'activity_display_day_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/activity_display_day/ActivityDisplayDayView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_DISPLAY_DAY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý thời gian hiển thị',
                link: 'activity_display_day_list',
              },
              {
                name: 'Chi tiết thời gian hiển thị',
              },
              {
                name: 'Chi tiết thời gian hiển thị',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_display_day/:form_type/:id?',
          name: 'activity_display_day_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/activity_display_day/ActivityDisplayDayUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_DISPLAY_DAY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục thời gian hiển thị',
                link: 'activity_display_day_list',
              },
              {
                createName: 'Thêm mới thời gian hiển thị',
                editName: 'Chỉnh sửa thời gian hiển thị',
                link: 'activity_display_day_edit',
                active: true,
              },
            ],
          },
        },
        // ActivityDisplayDay: END
        // ProgramActivity: BEGIN
        {
          path: 'program_activity',
          name: 'program_activity_list',
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity',
          name: 'program_activity_list_filter',
          component: () =>
            import(
              '@/view/pages/program_activity/ProgramActivityListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
              },
              {
                name: 'Danh sách hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity/create',
          name: 'program_activity_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
                link: 'program_activity_list',
              },
              {
                name: 'Thêm mới hoạt động',
              },
              {
                name: 'Tạo mới hoạt động',
                link: 'program_activity_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity/:id?',
          name: 'program_activity_view',
          props: true,
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động',
                link: 'program_activity_list',
              },
              {
                name: 'Chi tiết hoạt động',
              },
              {
                name: 'Chi tiết hoạt động',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_activity/:form_type/:id?',
          name: 'program_activity_edit',
          props: true,
          component: () =>
            import('@/view/pages/program_activity/ProgramActivityUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục hoạt động',
                link: 'program_activity_list',
              },
              {
                createName: 'Thêm mới hoạt động',
                editName: 'Chỉnh sửa hoạt động',
                link: 'program_activity_edit',
                active: true,
              },
            ],
          },
        },
        // ProgramActivity: END
        // ActivityParameter: BEGIN
        {
          path: 'activity_parameter',
          name: 'activity_parameter_list',
          component: () =>
            import('@/view/pages/activity_parameter/ActivityParameterList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý ActivityParameter',
              },
              {
                name: 'Danh sách ActivityParameter',
              },
              {
                name: 'Danh sách activityParameter',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_parameter',
          name: 'activity_parameter_list_filter',
          component: () =>
            import(
              '@/view/pages/activity_parameter/ActivityParameterListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý ActivityParameter',
              },
              {
                name: 'Danh sách ActivityParameter',
              },
              {
                name: 'Danh sách activityParameter',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_parameter/create',
          name: 'activity_parameter_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/activity_parameter/ActivityParameterCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý ActivityParameter',
                link: 'activity_parameter_list',
              },
              {
                name: 'Thêm mới ActivityParameter',
              },
              {
                name: 'Tạo mới ActivityParameter',
                link: 'activity_parameter_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_parameter/:id?',
          name: 'activity_parameter_view',
          props: true,
          component: () =>
            import('@/view/pages/activity_parameter/ActivityParameterView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý ActivityParameter',
                link: 'activity_parameter_list',
              },
              {
                name: 'Chi tiết ActivityParameter',
              },
              {
                name: 'Chi tiết ActivityParameter',
                active: true,
              },
            ],
          },
        },
        {
          path: 'activity_parameter/:form_type/:id?',
          name: 'activity_parameter_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/activity_parameter/ActivityParameterUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục ActivityParameter',
                link: 'activity_parameter_list',
              },
              {
                createName: 'Thêm mới ActivityParameter',
                editName: 'Chỉnh sửa ActivityParameter',
                link: 'activity_parameter_edit',
                active: true,
              },
            ],
          },
        },
        // ActivityParameter: END
        // ProgramModule: BEGIN
        {
          path: 'program_module',
          name: 'program_module_list',
          component: () =>
            import('@/view/pages/program_module/ProgramModuleList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Module',
              },
              {
                name: 'Danh sách Module',
              },
              {
                name: 'Danh sách Module',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module',
          name: 'program_module_list_filter',
          component: () =>
            import('@/view/pages/program_module/ProgramModuleListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Module',
              },
              {
                name: 'Danh sách Module',
              },
              {
                name: 'Danh sách Module',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module/create',
          name: 'program_module_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/program_module/ProgramModuleUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý Module',
                link: 'program_module_list',
              },
              {
                name: 'Thêm mới Module',
              },
              {
                name: 'Tạo mới Module',
                link: 'program_module_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module/:id?',
          name: 'program_module_view',
          props: true,
          component: () =>
            import('@/view/pages/program_module/ProgramModuleView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý Module',
                link: 'program_module_list',
              },
              {
                name: 'Chi tiết Module',
              },
              {
                name: 'Chi tiết Module',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module/:form_type/:id?',
          name: 'program_module_edit',
          props: true,
          component: () =>
            import('@/view/pages/program_module/ProgramModuleUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục chuyên đề chương trình',
                link: 'program_module_list',
              },
              {
                createName: 'Thêm mới chuyên đề chương trình',
                editName: 'Chỉnh sửa chuyên đề chương trình',
                link: 'program_module_edit',
                active: true,
              },
            ],
          },
        },
        // ProgramModule: END
        // Program: BEGIN
        {
          path: 'program',
          name: 'program_list',
          component: () => import('@/view/pages/program/ProgramList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chương trình',
              },
              {
                name: 'Danh sách chương trình',
              },
              {
                name: 'Danh sách chương trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program',
          name: 'program_list_filter',
          component: () => import('@/view/pages/program/ProgramListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chương trình',
              },
              {
                name: 'Danh sách chương trình',
              },
              {
                name: 'Danh sách chương trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program/create',
          name: 'program_update',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () => import('@/view/pages/program/ProgramUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý chương trình',
                link: 'program_list',
              },
              {
                name: 'Thêm mới chương trình',
              },
              {
                name: 'Tạo mới chương trình',
                link: 'program_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program/:id?',
          name: 'program_view',
          props: true,
          component: () => import('@/view/pages/program/ProgramView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý chương trình',
                link: 'program_list',
              },
              {
                name: 'Chi tiết chương trình',
              },
              {
                name: 'Chi tiết chương trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program/:form_type/:id?',
          name: 'program_edit',
          props: true,
          component: () => import('@/view/pages/program/ProgramUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục chương trình',
                link: 'program_list',
              },
              {
                createName: 'Thêm mới chương trình',
                editName: 'Chỉnh sửa chương trình',
                link: 'program_edit',
                active: true,
              },
            ],
          },
        },
        // Program: END
        // ProgramModuleActivity: BEGIN
        {
          path: 'program_module_activity',
          name: 'program_module_activity_list',
          component: () =>
            import(
              '@/view/pages/program_module_activity/ProgramModuleActivityList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động chuyên đề chương trình',
              },
              {
                name: 'Danh sách hoạt động chuyên đề chương trình',
              },
              {
                name: 'Danh sách hoạt động chuyên đề chương trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module_activity',
          name: 'program_module_activity_list_filter',
          component: () =>
            import(
              '@/view/pages/program_module_activity/ProgramModuleActivityListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động chuyên đề chương trình',
              },
              {
                name: 'Danh sách hoạt động chuyên đề chương trình',
              },
              {
                name: 'Danh sách hoạt động chuyên đề chương trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module_activity/create',
          name: 'program_module_activity_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/program_module_activity/ProgramModuleActivityCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động chuyên đề chương trình',
                link: 'program_module_activity_list',
              },
              {
                name: 'Thêm mới hoạt động chuyên đề chương trình',
              },
              {
                name: 'Tạo mới hoạt động chuyên đề chương trình',
                link: 'program_module_activity_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module_activity/:id?',
          name: 'program_module_activity_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_module_activity/ProgramModuleActivityView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý hoạt động chuyên đề chương trình',
                link: 'program_module_activity_list',
              },
              {
                name: 'Chi tiết hoạt động chuyên đề chương trình',
              },
              {
                name: 'Chi tiết hoạt động chuyên đề chương trình',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_module_activity/:form_type/:id?',
          name: 'program_module_activity_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_module_activity/ProgramModuleActivityUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục hoạt động chuyên đề chương trình',
                link: 'program_module_activity_list',
              },
              {
                createName: 'Thêm mới hoạt động chuyên đề chương trình',
                editName: 'Chỉnh sửa hoạt động chuyên đề chương trình',
                link: 'program_module_activity_edit',
                active: true,
              },
            ],
          },
        },
        // ProgramModuleActivity: END
        // ProgramProgramModule: BEGIN
        {
          path: 'program_program_module',
          name: 'program_program_module_list',
          component: () =>
            import(
              '@/view/pages/program_program_module/ProgramProgramModuleList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý ProgramProgramModule',
              },
              {
                name: 'Danh sách ProgramProgramModule',
              },
              {
                name: 'Danh sách programProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_program_module',
          name: 'program_program_module_list_filter',
          component: () =>
            import(
              '@/view/pages/program_program_module/ProgramProgramModuleListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý ProgramProgramModule',
              },
              {
                name: 'Danh sách ProgramProgramModule',
              },
              {
                name: 'Danh sách programProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_program_module/create',
          name: 'program_program_module_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/program_program_module/ProgramProgramModuleCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý ProgramProgramModule',
                link: 'program_program_module_list',
              },
              {
                name: 'Thêm mới ProgramProgramModule',
              },
              {
                name: 'Tạo mới ProgramProgramModule',
                link: 'program_program_module_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_program_module/:id?',
          name: 'program_program_module_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_program_module/ProgramProgramModuleView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý ProgramProgramModule',
                link: 'program_program_module_list',
              },
              {
                name: 'Chi tiết ProgramProgramModule',
              },
              {
                name: 'Chi tiết ProgramProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'program_program_module/:form_type/:id?',
          name: 'program_program_module_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/program_program_module/ProgramProgramModuleUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục ProgramProgramModule',
                link: 'program_program_module_list',
              },
              {
                createName: 'Thêm mới ProgramProgramModule',
                editName: 'Chỉnh sửa ProgramProgramModule',
                link: 'program_program_module_edit',
                active: true,
              },
            ],
          },
        },

        {
          path: 'tran_user_package',
          name: 'tran_user_package_list',
          component: () =>
            import('@/view/pages/tran_user_package/TranUserPackageList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách người dùng gói dịch vụ',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_user_package/:id',
          name: 'tran_user_package_view',
          props: true,
          component: () =>
            import('@/view/pages/tran_user_package/TranUserPackageView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý người dùng gói dịch vụ',
              },
              {
                name: 'Danh sách người dùng gói dịch vụ',
                link: 'tran_user_package_list',
              },
              {
                name: 'Chi tiết hoạt động người dùng',
                active: true,
              },
            ],
          },
        },
        // ProgramProgramModule: END
        // TranProgram: BEGIN
        {
          path: 'tran_program',
          name: 'tran_program_list',
          component: () =>
            import('@/view/pages/tran_program/TranProgramList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgram',
              },
              {
                name: 'Danh sách TranProgram',
              },
              {
                name: 'Danh sách tranProgram',
                active: true,
              },
            ],
          },
        },

        {
          path: 'tran_program',
          name: 'tran_program_list_filter',
          component: () =>
            import('@/view/pages/tran_program/TranProgramListFilter.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgram',
              },
              {
                name: 'Danh sách TranProgram',
              },
              {
                name: 'Danh sách tranProgram',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program/create',
          name: 'tran_program_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/tran_program/TranProgramCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranProgram',
                link: 'tran_program_list',
              },
              {
                name: 'Thêm mới TranProgram',
              },
              {
                name: 'Tạo mới TranProgram',
                link: 'tran_program_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program/:id?',
          name: 'tran_program_view',
          props: true,
          component: () =>
            import('@/view/pages/tran_program/TranProgramView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgram',
                link: 'tran_program_list',
              },
              {
                name: 'Chi tiết TranProgram',
              },
              {
                name: 'Chi tiết TranProgram',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program/:form_type/:id?',
          name: 'tran_program_edit',
          props: true,
          component: () =>
            import('@/view/pages/tran_program/TranProgramUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranProgram',
                link: 'tran_program_list',
              },
              {
                createName: 'Thêm mới TranProgram',
                editName: 'Chỉnh sửa TranProgram',
                link: 'tran_program_edit',
                active: true,
              },
            ],
          },
        },
        // TranProgram: END
        // TranProgramActivity: BEGIN
        {
          path: 'tran_program_activity',
          name: 'tran_program_activity_list',
          component: () =>
            import(
              '@/view/pages/tran_program_activity/TranProgramActivityList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivity',
              },
              {
                name: 'Danh sách TranProgramActivity',
              },
              {
                name: 'Danh sách tranProgramActivity',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity',
          name: 'tran_program_activity_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_program_activity/TranProgramActivityListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivity',
              },
              {
                name: 'Danh sách TranProgramActivity',
              },
              {
                name: 'Danh sách tranProgramActivity',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity/create',
          name: 'tran_program_activity_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_program_activity/TranProgramActivityCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivity',
                link: 'tran_program_activity_list',
              },
              {
                name: 'Thêm mới TranProgramActivity',
              },
              {
                name: 'Tạo mới TranProgramActivity',
                link: 'tran_program_activity_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity/:id?',
          name: 'tran_program_activity_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_activity/TranProgramActivityView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivity',
                link: 'tran_program_activity_list',
              },
              {
                name: 'Chi tiết TranProgramActivity',
              },
              {
                name: 'Chi tiết TranProgramActivity',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity/:form_type/:id?',
          name: 'tran_program_activity_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_activity/TranProgramActivityUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranProgramActivity',
                link: 'tran_program_activity_list',
              },
              {
                createName: 'Thêm mới TranProgramActivity',
                editName: 'Chỉnh sửa TranProgramActivity',
                link: 'tran_program_activity_edit',
                active: true,
              },
            ],
          },
        },
        // TranProgramActivity: END
        // TranActivityParameter: BEGIN
        {
          path: 'tran_activity_parameter',
          name: 'tran_activity_parameter_list',
          component: () =>
            import(
              '@/view/pages/tran_activity_parameter/TranActivityParameterList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranActivityParameter',
              },
              {
                name: 'Danh sách TranActivityParameter',
              },
              {
                name: 'Danh sách tranActivityParameter',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_activity_parameter',
          name: 'tran_activity_parameter_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_activity_parameter/TranActivityParameterListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranActivityParameter',
              },
              {
                name: 'Danh sách TranActivityParameter',
              },
              {
                name: 'Danh sách tranActivityParameter',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_activity_parameter/create',
          name: 'tran_activity_parameter_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_activity_parameter/TranActivityParameterCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranActivityParameter',
                link: 'tran_activity_parameter_list',
              },
              {
                name: 'Thêm mới TranActivityParameter',
              },
              {
                name: 'Tạo mới TranActivityParameter',
                link: 'tran_activity_parameter_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_activity_parameter/:id?',
          name: 'tran_activity_parameter_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_activity_parameter/TranActivityParameterView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranActivityParameter',
                link: 'tran_activity_parameter_list',
              },
              {
                name: 'Chi tiết TranActivityParameter',
              },
              {
                name: 'Chi tiết TranActivityParameter',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_activity_parameter/:form_type/:id?',
          name: 'tran_activity_parameter_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_activity_parameter/TranActivityParameterUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_ACTIVITY_PARAMETER,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranActivityParameter',
                link: 'tran_activity_parameter_list',
              },
              {
                createName: 'Thêm mới TranActivityParameter',
                editName: 'Chỉnh sửa TranActivityParameter',
                link: 'tran_activity_parameter_edit',
                active: true,
              },
            ],
          },
        },
        // TranActivityParameter: END
        // TranProgramActivityReminder: BEGIN
        {
          path: 'tran_program_activity_reminder',
          name: 'tran_program_activity_reminder_list',
          component: () =>
            import(
              '@/view/pages/tran_program_activity_reminder/TranProgramActivityReminderList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivityReminder',
              },
              {
                name: 'Danh sách TranProgramActivityReminder',
              },
              {
                name: 'Danh sách tranProgramActivityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity_reminder',
          name: 'tran_program_activity_reminder_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_program_activity_reminder/TranProgramActivityReminderListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivityReminder',
              },
              {
                name: 'Danh sách TranProgramActivityReminder',
              },
              {
                name: 'Danh sách tranProgramActivityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity_reminder/create',
          name: 'tran_program_activity_reminder_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_program_activity_reminder/TranProgramActivityReminderCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivityReminder',
                link: 'tran_program_activity_reminder_list',
              },
              {
                name: 'Thêm mới TranProgramActivityReminder',
              },
              {
                name: 'Tạo mới TranProgramActivityReminder',
                link: 'tran_program_activity_reminder_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity_reminder/:id?',
          name: 'tran_program_activity_reminder_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_activity_reminder/TranProgramActivityReminderView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramActivityReminder',
                link: 'tran_program_activity_reminder_list',
              },
              {
                name: 'Chi tiết TranProgramActivityReminder',
              },
              {
                name: 'Chi tiết TranProgramActivityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_activity_reminder/:form_type/:id?',
          name: 'tran_program_activity_reminder_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_activity_reminder/TranProgramActivityReminderUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranProgramActivityReminder',
                link: 'tran_program_activity_reminder_list',
              },
              {
                createName: 'Thêm mới TranProgramActivityReminder',
                editName: 'Chỉnh sửa TranProgramActivityReminder',
                link: 'tran_program_activity_reminder_edit',
                active: true,
              },
            ],
          },
        },
        // TranProgramActivityReminder: END
        // TranProgramModule: BEGIN
        {
          path: 'tran_program_module',
          name: 'tran_program_module_list',
          component: () =>
            import(
              '@/view/pages/tran_program_module/TranProgramModuleList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModule',
              },
              {
                name: 'Danh sách TranProgramModule',
              },
              {
                name: 'Danh sách tranProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module',
          name: 'tran_program_module_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_program_module/TranProgramModuleListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModule',
              },
              {
                name: 'Danh sách TranProgramModule',
              },
              {
                name: 'Danh sách tranProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module/create',
          name: 'tran_program_module_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_program_module/TranProgramModuleCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModule',
                link: 'tran_program_module_list',
              },
              {
                name: 'Thêm mới TranProgramModule',
              },
              {
                name: 'Tạo mới TranProgramModule',
                link: 'tran_program_module_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module/:id?',
          name: 'tran_program_module_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_module/TranProgramModuleView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModule',
                link: 'tran_program_module_list',
              },
              {
                name: 'Chi tiết TranProgramModule',
              },
              {
                name: 'Chi tiết TranProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module/:form_type/:id?',
          name: 'tran_program_module_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_module/TranProgramModuleUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranProgramModule',
                link: 'tran_program_module_list',
              },
              {
                createName: 'Thêm mới TranProgramModule',
                editName: 'Chỉnh sửa TranProgramModule',
                link: 'tran_program_module_edit',
                active: true,
              },
            ],
          },
        },
        // TranProgramModule: END
        // TranProgramModuleActivity: BEGIN
        {
          path: 'tran_program_module_activity',
          name: 'tran_program_module_activity_list',
          component: () =>
            import(
              '@/view/pages/tran_program_module_activity/TranProgramModuleActivityList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModuleActivity',
              },
              {
                name: 'Danh sách TranProgramModuleActivity',
              },
              {
                name: 'Danh sách tranProgramModuleActivity',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module_activity',
          name: 'tran_program_module_activity_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_program_module_activity/TranProgramModuleActivityListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModuleActivity',
              },
              {
                name: 'Danh sách TranProgramModuleActivity',
              },
              {
                name: 'Danh sách tranProgramModuleActivity',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module_activity/create',
          name: 'tran_program_module_activity_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_program_module_activity/TranProgramModuleActivityCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModuleActivity',
                link: 'tran_program_module_activity_list',
              },
              {
                name: 'Thêm mới TranProgramModuleActivity',
              },
              {
                name: 'Tạo mới TranProgramModuleActivity',
                link: 'tran_program_module_activity_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module_activity/:id?',
          name: 'tran_program_module_activity_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_module_activity/TranProgramModuleActivityView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramModuleActivity',
                link: 'tran_program_module_activity_list',
              },
              {
                name: 'Chi tiết TranProgramModuleActivity',
              },
              {
                name: 'Chi tiết TranProgramModuleActivity',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_module_activity/:form_type/:id?',
          name: 'tran_program_module_activity_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_module_activity/TranProgramModuleActivityUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_MODULE_ACTIVITY,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranProgramModuleActivity',
                link: 'tran_program_module_activity_list',
              },
              {
                createName: 'Thêm mới TranProgramModuleActivity',
                editName: 'Chỉnh sửa TranProgramModuleActivity',
                link: 'tran_program_module_activity_edit',
                active: true,
              },
            ],
          },
        },
        // TranProgramModuleActivity: END
        // TranProgramProgramModule: BEGIN
        {
          path: 'tran_program_program_module',
          name: 'tran_program_program_module_list',
          component: () =>
            import(
              '@/view/pages/tran_program_program_module/TranProgramProgramModuleList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramProgramModule',
              },
              {
                name: 'Danh sách TranProgramProgramModule',
              },
              {
                name: 'Danh sách tranProgramProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_program_module',
          name: 'tran_program_program_module_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_program_program_module/TranProgramProgramModuleListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramProgramModule',
              },
              {
                name: 'Danh sách TranProgramProgramModule',
              },
              {
                name: 'Danh sách tranProgramProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_program_module/create',
          name: 'tran_program_program_module_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_program_program_module/TranProgramProgramModuleCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramProgramModule',
                link: 'tran_program_program_module_list',
              },
              {
                name: 'Thêm mới TranProgramProgramModule',
              },
              {
                name: 'Tạo mới TranProgramProgramModule',
                link: 'tran_program_program_module_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_program_module/:id?',
          name: 'tran_program_program_module_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_program_module/TranProgramProgramModuleView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranProgramProgramModule',
                link: 'tran_program_program_module_list',
              },
              {
                name: 'Chi tiết TranProgramProgramModule',
              },
              {
                name: 'Chi tiết TranProgramProgramModule',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_program_program_module/:form_type/:id?',
          name: 'tran_program_program_module_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_program_program_module/TranProgramProgramModuleUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_PROGRAM_PROGRAM_MODULE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranProgramProgramModule',
                link: 'tran_program_program_module_list',
              },
              {
                createName: 'Thêm mới TranProgramProgramModule',
                editName: 'Chỉnh sửa TranProgramProgramModule',
                link: 'tran_program_program_module_edit',
                active: true,
              },
            ],
          },
        },
        // TranProgramProgramModule: END
        // TranServicePackage: BEGIN
        {
          path: 'tran_service_package',
          name: 'tran_service_package_list',
          component: () =>
            import(
              '@/view/pages/tran_service_package/TranServicePackageList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranServicePackage',
              },
              {
                name: 'Danh sách TranServicePackage',
              },
              {
                name: 'Danh sách tranServicePackage',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_service_package',
          name: 'tran_service_package_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_service_package/TranServicePackageListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranServicePackage',
              },
              {
                name: 'Danh sách TranServicePackage',
              },
              {
                name: 'Danh sách tranServicePackage',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_service_package/create',
          name: 'tran_service_package_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_service_package/TranServicePackageCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranServicePackage',
                link: 'tran_service_package_list',
              },
              {
                name: 'Thêm mới TranServicePackage',
              },
              {
                name: 'Tạo mới TranServicePackage',
                link: 'tran_service_package_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_service_package/:id?',
          name: 'tran_service_package_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_service_package/TranServicePackageView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranServicePackage',
                link: 'tran_service_package_list',
              },
              {
                name: 'Chi tiết TranServicePackage',
              },
              {
                name: 'Chi tiết TranServicePackage',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_service_package/:form_type/:id?',
          name: 'tran_service_package_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_service_package/TranServicePackageUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_SERVICE_PACKAGE,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranServicePackage',
                link: 'tran_service_package_list',
              },
              {
                createName: 'Thêm mới TranServicePackage',
                editName: 'Chỉnh sửa TranServicePackage',
                link: 'tran_service_package_edit',
                active: true,
              },
            ],
          },
        },
        // TranServicePackage: END
        // TranUserPackageActivityReminder: BEGIN
        {
          path: 'tran_user_package_activity_reminder',
          name: 'tran_user_package_activity_reminder_list',
          component: () =>
            import(
              '@/view/pages/tran_user_package_activity_reminder/TranUserPackageActivityReminderList.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranUserPackageActivityReminder',
              },
              {
                name: 'Danh sách TranUserPackageActivityReminder',
              },
              {
                name: 'Danh sách tranUserPackageActivityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_user_package_activity_reminder',
          name: 'tran_user_package_activity_reminder_list_filter',
          component: () =>
            import(
              '@/view/pages/tran_user_package_activity_reminder/TranUserPackageActivityReminderListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranUserPackageActivityReminder',
              },
              {
                name: 'Danh sách TranUserPackageActivityReminder',
              },
              {
                name: 'Danh sách tranUserPackageActivityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_user_package_activity_reminder/create',
          name: 'tran_user_package_activity_reminder_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import(
              '@/view/pages/tran_user_package_activity_reminder/TranUserPackageActivityReminderCreate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý TranUserPackageActivityReminder',
                link: 'tran_user_package_activity_reminder_list',
              },
              {
                name: 'Thêm mới TranUserPackageActivityReminder',
              },
              {
                name: 'Tạo mới TranUserPackageActivityReminder',
                link: 'tran_user_package_activity_reminder_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_user_package_activity_reminder/:id?',
          name: 'tran_user_package_activity_reminder_view',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_user_package_activity_reminder/TranUserPackageActivityReminderView.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý TranUserPackageActivityReminder',
                link: 'tran_user_package_activity_reminder_list',
              },
              {
                name: 'Chi tiết TranUserPackageActivityReminder',
              },
              {
                name: 'Chi tiết TranUserPackageActivityReminder',
                active: true,
              },
            ],
          },
        },
        {
          path: 'tran_user_package_activity_reminder/:form_type/:id?',
          name: 'tran_user_package_activity_reminder_edit',
          props: true,
          component: () =>
            import(
              '@/view/pages/tran_user_package_activity_reminder/TranUserPackageActivityReminderUpdate.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.TRAN_USER_PACKAGE_ACTIVITY_REMINDER,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục TranUserPackageActivityReminder',
                link: 'tran_user_package_activity_reminder_list',
              },
              {
                createName: 'Thêm mới TranUserPackageActivityReminder',
                editName: 'Chỉnh sửa TranUserPackageActivityReminder',
                link: 'tran_user_package_activity_reminder_edit',
                active: true,
              },
            ],
          },
        },
        // TranUserPackageActivityReminder: END
        // CustomerPartner: BEGIN
        {
          path: 'customer_partner',
          name: 'customer_partner_list',
          component: () =>
            import('@/view/pages/customer_partner/CustomerPartnerList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý CustomerPartner',
              },
              {
                name: 'Danh sách CustomerPartner',
              },
              {
                name: 'Danh sách customerPartner',
                active: true,
              },
            ],
          },
        },
        {
          path: 'customer_partner',
          name: 'customer_partner_list_filter',
          component: () =>
            import(
              '@/view/pages/customer_partner/CustomerPartnerListFilter.vue'
            ),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý CustomerPartner',
              },
              {
                name: 'Danh sách CustomerPartner',
              },
              {
                name: 'Danh sách customerPartner',
                active: true,
              },
            ],
          },
        },
        {
          path: 'customer_partner/create',
          name: 'customer_partner_create',
          props: {
            form_type: 'create', // Set props to pass to the component
          },
          component: () =>
            import('@/view/pages/customer_partner/CustomerPartnerCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_PARTNER,
            permissions: [PERMISSION_TYPE.INSERT],
            breadcrumb: [
              {
                name: 'Quản lý CustomerPartner',
                link: 'customer_partner_list',
              },
              {
                name: 'Thêm mới CustomerPartner',
              },
              {
                name: 'Tạo mới CustomerPartner',
                link: 'customer_partner_create',
                active: true,
              },
            ],
          },
        },
        {
          path: 'customer_partner/:id?',
          name: 'customer_partner_view',
          props: true,
          component: () =>
            import('@/view/pages/customer_partner/CustomerPartnerView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              {
                name: 'Quản lý CustomerPartner',
                link: 'customer_partner_list',
              },
              {
                name: 'Chi tiết CustomerPartner',
              },
              {
                name: 'Chi tiết CustomerPartner',
                active: true,
              },
            ],
          },
        },
        {
          path: 'customer_partner/:form_type/:id?',
          name: 'customer_partner_edit',
          props: true,
          component: () =>
            import('@/view/pages/customer_partner/CustomerPartnerUpdate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.CUSTOMER_PARTNER,
            permissions: [PERMISSION_TYPE.INSERT, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              {
                name: 'Danh mục CustomerPartner',
                link: 'customer_partner_list',
              },
              {
                name: 'Chi tiết CustomerPartner',
              },
              {
                name: 'Chi tiết CustomerPartner',
                active: true,
              },
            ],
          }
        },
        {
          path: 'clinic_dashboard',
          name: 'clinic_dashboard',
          component: () =>
            import('@/view/pages/clinic_bundle/ClinicDashboard.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.CLINIC_DASHBOARD,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Dashboard',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_management',
          name: 'package_management',
          component: () =>
            import('@/view/pages/clinic_bundle/PackageManagement.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_MANAGEMENT,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Management',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_management/create',
          name: 'package_management_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/PackageManagementEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_MANAGEMENT,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Management',
                to: { name: 'package_management' },
              },
              {
                name: 'Thêm mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_management/edit/:id',
          name: 'package_management_edit',
          props: true,
          component: () =>
            import('@/view/pages/clinic_bundle/components/PackageManagementEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_MANAGEMENT,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Management',
                to: { name: 'package_management' },
              },
              {
                name: 'Chỉnh sửa',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_management/view/:id',
          name: 'package_management_view',
          props: true,
          component: () =>
            import('@/view/pages/clinic_bundle/components/PackageManagementView.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_MANAGEMENT,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Management',
                to: { name: 'package_management' },
              },
              {
                name: 'Chi tiết',
                active: true,
              },
            ],
          },
        },
        {
          path: 'services_products',
          name: 'services_products',
          component: () =>
            import('@/view/pages/clinic_bundle/ServicesProducts.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.SERVICES_PRODUCTS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Services & Products',
                active: true,
              },
            ],
          },
        },
        {
          path: 'medicine/create',
          name: 'medicine_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/MedicineEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.SERVICES_PRODUCTS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Services & Products',
                to: { name: 'services_products' },
              },
              {
                name: 'Thêm mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'medicine/edit/:id',
          name: 'medicine_edit',
          props: true,
          component: () =>
            import('@/view/pages/clinic_bundle/components/MedicineEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.SERVICES_PRODUCTS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Services & Products',
                to: { name: 'services_products' },
              },
              {
                name: 'Chỉnh sửa',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service/create',
          name: 'service_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/ServiceEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.SERVICES_PRODUCTS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Services & Products',
                to: { name: 'services_products' },
              },
              {
                name: 'Thêm mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'service/edit/:id',
          name: 'service_edit',
          props: true,
          component: () =>
            import('@/view/pages/clinic_bundle/components/ServiceEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.SERVICES_PRODUCTS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Services & Products',
                to: { name: 'services_products' },
              },
              {
                name: 'Chỉnh sửa',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_registration',
          name: 'package_registration',
          component: () =>
            import('@/view/pages/clinic_bundle/PackageRegistration.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_REGISTRATION,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Registration',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_registration/create',
          name: 'package_registration_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/PackageRegistrationCreate.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_REGISTRATION,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Registration',
                to: { name: 'package_registration' },
              },
              {
                name: 'Đăng ký mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'package_registration/detail/:id',
          name: 'package_registration_detail',
          props: true,
          component: () =>
            import('@/view/pages/clinic_bundle/components/PackageRegistrationDetail.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.PACKAGE_REGISTRATION,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Package Registration',
                to: { name: 'package_registration' },
              },
              {
                name: 'Chi tiết đăng ký',
                active: true,
              },
            ],
          },
        },
        {
          path: 'coach_note/dashboard',
          name: 'coach_note_dashboard',
          component: () =>
            import('@/view/pages/coach_note/CoachNoteDashboard.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.COACH_NOTE_DASHBOARD,
            breadcrumb: [
              { name: 'Chương trình' },
              { name: 'Dashboard - Operator', active: true },
            ],
          },
        },
        {
          path: 'coach_note/detail/:userPackageId/:phoneNumber',
          name: 'coach_note_detail',
          props: true,
          component: () =>
            import('@/view/pages/coach_note/CoachNoteDetail.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.COACH_NOTE,
            breadcrumb: [
              { name: 'Coach Note' },
              { name: 'Chi tiết', active: true },
            ],
          },
        },
        {
          path: 'usage_recording',
          name: 'usage_recording',
          component: () =>
            import('@/view/pages/clinic_bundle/UsageRecording.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.USAGE_RECORDING,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Usage Recording',
                active: true,
              },
            ],
          },
        },
        {
          path: 'usage_recording/create',
          name: 'usage_recording_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/UsageRecordingCreate.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.USAGE_RECORDING,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Usage Recording',
                to: { name: 'usage_recording' },
              },
              {
                name: 'Ghi nhận mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'clinic_voucher',
          name: 'clinic_voucher',
          component: () =>
            import('@/view/pages/clinic_bundle/ClinicVoucher.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.VOUCHERS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Voucher',
                active: true,
              },
            ],
          },
        },
        {
          path: 'clinic_voucher/edit/:id',
          name: 'clinic_voucher_edit',
          component: () =>
            import('@/view/pages/clinic_bundle/components/VoucherEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.VOUCHERS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Voucher',
                link: 'clinic_voucher',
              },
              {
                name: 'Chỉnh sửa voucher',
                active: true,
              },
            ],
          },
        },
        {
          path: 'clinic_voucher/create',
          name: 'clinic_voucher_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/VoucherEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.VOUCHERS,
            breadcrumb: [
              {
                name: 'Clinic Bundle',
              },
              {
                name: 'Voucher',
                link: 'clinic_voucher',
              },
              {
                name: 'Tạo voucher mới',
                active: true,
              },
            ],
          },
        },
        {
          path: 'benefit-type',
          name: 'benefit_type',
          component: () =>
            import('@/view/pages/clinic_bundle/BenefitType.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.BENEFIT_TYPE,
            breadcrumb: [
              { name: 'Clinic Bundle' },
              { name: 'Ưu đãi', active: true },
            ],
          },
        },
        {
          path: 'benefit-type/create',
          name: 'benefit_type_create',
          component: () =>
            import('@/view/pages/clinic_bundle/components/BenefitTypeEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.BENEFIT_TYPE,
            breadcrumb: [
              { name: 'Clinic Bundle' },
              { name: 'Ưu đãi', link: 'benefit_type' },
              { name: 'Tạo mới ưu đãi', active: true },
            ],
          },
        },
        {
          path: 'benefit-type/edit/:id',
          name: 'benefit_type_edit',
          component: () =>
            import('@/view/pages/clinic_bundle/components/BenefitTypeEdit.vue'),
          meta: {
            requiresAuth: true,
            permissions: [PERMISSION_TYPE.VIEW],
            pageCode: PAGE_CODE.BENEFIT_TYPE,
            breadcrumb: [
              { name: 'Clinic Bundle' },
              { name: 'Ưu đãi', link: 'benefit_type' },
              { name: 'Chỉnh sửa ưu đãi', active: true },
            ],
          },
        },
        // CLINIC BUNDLE: END

        // BCB BUNDLE CAMPAIGN: START
        {
          path: 'bcb-campaign',
          name: 'bcb-campaign',
          component: () =>
            import('@/view/pages/bcb_campaign/BcbCampaignList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách chiến dịch', active: true },
            ],
          },
        },
        {
          path: 'bcb-exam-calendar',
          name: 'bcb-exam-calendar',
          component: () =>
            import('@/view/pages/bcb_campaign/BcbExamCalendar.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Lịch khám', active: true },
            ],
          },
        },
        {
          path: 'bcb-campaign-customers',
          name: 'bcb-campaign-customer-list',
          component: () =>
            import('@/view/pages/bcb_campaign/BcbCampaignCustomerList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN_CUSTOMER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách khách hàng', active: true },
            ],
          },
        },
        {
          path: 'bcb-campaign/create',
          name: 'bcb-campaign-create',
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbCampaignCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN,
            permissions: [PERMISSION_TYPE.VIEW, PERMISSION_TYPE.INSERT],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách chiến dịch', link: 'bcb-campaign' },
              { name: 'Tạo chiến dịch mới', active: true },
            ],
          },
        },
        {
          path: 'bcb-campaign/:id/edit',
          name: 'bcb-campaign-edit',
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbCampaignCreate.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN,
            permissions: [PERMISSION_TYPE.VIEW, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách chiến dịch', link: 'bcb-campaign' },
              { name: 'Chỉnh sửa chiến dịch', active: true },
            ],
          },
        },
        {
          path: 'bcb-campaign/:id/detail',
          name: 'bcb-campaign-detail',
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbCampaignDetail.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách chiến dịch', link: 'bcb-campaign' },
              { name: 'Chi tiết chiến dịch', active: true },
            ],
          },
        },
        {
          path: 'bcb-campaign/:campaignId/customer/:customerId',
          name: 'bcb-campaign-customer-detail',
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbCustomerDetail.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN_CUSTOMER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách chiến dịch', link: 'bcb-campaign' },
              { name: 'Chi tiết khách hàng', active: true },
            ],
          },
        },
        {
          path: 'bcb-customer/:customerId',
          name: 'bcb-customer-view',
          props: true,
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbCustomerDetail.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN_CUSTOMER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Danh sách khách hàng', link: 'bcb-campaign-customer-list' },
              { name: 'Chi tiết khách hàng', active: true },
            ],
          },
        },
        {
          path: 'bcb-campaign-customer/:campaignCustomerId/results',
          name: 'bcb-campaign-customer-results',
          props: true,
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbCustomerExamResultView.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_CAMPAIGN_CUSTOMER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Ket qua kham', active: true },
            ],
          },
        },
        {
          path: 'bcb-partner',
          name: 'bcb-partner',
          component: () =>
            import('@/view/pages/bcb_campaign/BcbPartnerList.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Quản lý đối tác', active: true },
            ],
          },
        },
        {
          path: 'bcb-partner/create',
          name: 'bcb-partner-create',
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbPartnerEdit.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW, PERMISSION_TYPE.INSERT],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Đối tác', link: 'bcb-partner' },
              { name: 'Thêm đối tác', active: true },
            ],
          },
        },
        {
          path: 'bcb-partner/:id/edit',
          name: 'bcb-partner-edit',
          component: () =>
            import('@/view/pages/bcb_campaign/components/BcbPartnerEdit.vue'),
          meta: {
            requiresAuth: true,
            pageCode: PAGE_CODE.BCB_PARTNER,
            permissions: [PERMISSION_TYPE.VIEW, PERMISSION_TYPE.UPDATE],
            breadcrumb: [
              { name: 'BCB Bundle Campaign' },
              { name: 'Đối tác', link: 'bcb-partner' },
              { name: 'Chỉnh sửa đối tác', active: true },
            ],
          },
        },
        // BCB BUNDLE CAMPAIGN: END
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && store.state.auth.isAuthenticated) {
    store.dispatch(RESET_LAYOUT_CONFIG);

    const { pageCode, permissions: pagePermisstions } = to.meta;

    if (pageCode) {
      let permissions = store.state.auth.permissions;

      if (!permissions.length) {
        // localStorage đã lưu dạng [{code, value}] — dùng trực tiếp, không groupBy lại
        permissions = JSON.parse(localStorage.getItem('permissions')) || [];
        await store.commit(SET_PERMISSIONS, permissions);
      }

      const permissionWithPage = permissions
        .find((el) => el.code === pageCode)
        ?.value.map((el) => el.nameType);

      const resolvedPermissions = permissionWithPage || [];

      if (intersection(pagePermisstions, resolvedPermissions).length) {
        to.meta.isWritePermission =
          resolvedPermissions.includes(PERMISSION_TYPE.INSERT) ||
          resolvedPermissions.includes(PERMISSION_TYPE.UPDATE) ||
          resolvedPermissions.includes(PERMISSION_TYPE.DELETE);
        to.meta.isInsertPermission = resolvedPermissions.includes(PERMISSION_TYPE.INSERT);
        to.meta.isUpdatePermission = resolvedPermissions.includes(PERMISSION_TYPE.UPDATE);
        to.meta.isDeletePermission = resolvedPermissions.includes(PERMISSION_TYPE.DELETE);
        to.meta.isAssignPermission = resolvedPermissions.includes(PERMISSION_TYPE.ASSIGN);
        next();
      } else {
        // Không có quyền — hiện toast thiếu quyền gì, redirect về trang trước
        const PERM_NAMES = {
          [PERMISSION_TYPE.VIEW]: 'Xem',
          [PERMISSION_TYPE.INSERT]: 'Tạo mới',
          [PERMISSION_TYPE.UPDATE]: 'Cập nhật',
          [PERMISSION_TYPE.DELETE]: 'Xóa',
          [PERMISSION_TYPE.ASSIGN]: 'Gán dữ liệu',
        };
        const missingNames = (pagePermisstions || [])
          .filter((p) => !resolvedPermissions.includes(p))
          .map((p) => PERM_NAMES[p] || p)
          .join(', ');
        const breadcrumbs = to.meta.breadcrumb || [];
        const activeCrumb = breadcrumbs.find((b) => b.active) || breadcrumbs[breadcrumbs.length - 1];
        const pageName = activeCrumb?.name || to.name || pageCode;
        const msg = missingNames
          ? `Bạn thiếu quyền [${missingNames}] để truy cập trang "${pageName}"`
          : `Bạn không có quyền truy cập trang "${pageName}"`;
        window.dispatchEvent(new CustomEvent('api:forbidden', { detail: { message: msg } }));
        const redirectTo = from.name ? from.path : '/';
        next(redirectTo);
      }
    } else {
      next();
    }

    // Scroll page to top on every route change
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  } else {
    let mgs = new MgrService();
    await mgs.signOut();
  }
  // reset config to initial state
});

export default router;
